(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("34trM", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $23c89669719ee35e$export$6503ec6e8aabbaf; }, function (v) { return $23c89669719ee35e$export$6503ec6e8aabbaf = v; });
var $23c89669719ee35e$export$6503ec6e8aabbaf;
var $23c89669719ee35e$export$f7ad0328861e2f03;
"use strict";
var $23c89669719ee35e$var$mapping = new Map();
function $23c89669719ee35e$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$23c89669719ee35e$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $23c89669719ee35e$var$resolve(id) {
    var resolved = $23c89669719ee35e$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$23c89669719ee35e$export$6503ec6e8aabbaf = $23c89669719ee35e$var$register;
$23c89669719ee35e$export$f7ad0328861e2f03 = $23c89669719ee35e$var$resolve;

});

parcelRegister("gcgwq", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $bcaa954072bce149$export$bdfd709ae4826697; }, function (v) { return $bcaa954072bce149$export$bdfd709ae4826697 = v; });
var $bcaa954072bce149$export$bdfd709ae4826697;
var $bcaa954072bce149$export$c9e73fbda7da57b6;
var $bcaa954072bce149$export$5a759dc7a1cfb72a;
"use strict";
var $bcaa954072bce149$var$bundleURL = {};
function $bcaa954072bce149$var$getBundleURLCached(id) {
    var value = $bcaa954072bce149$var$bundleURL[id];
    if (!value) {
        value = $bcaa954072bce149$var$getBundleURL();
        $bcaa954072bce149$var$bundleURL[id] = value;
    }
    return value;
}
function $bcaa954072bce149$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $bcaa954072bce149$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $bcaa954072bce149$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $bcaa954072bce149$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$bcaa954072bce149$export$bdfd709ae4826697 = $bcaa954072bce149$var$getBundleURLCached;
$bcaa954072bce149$export$c9e73fbda7da57b6 = $bcaa954072bce149$var$getBaseURL;
$bcaa954072bce149$export$5a759dc7a1cfb72a = $bcaa954072bce149$var$getOrigin;

});

var $ee4c03801aa1900b$exports = {};


(parcelRequire("34trM")).register((parcelRequire("gcgwq")).getBundleURL('1dpzq'), JSON.parse("[\"1dpzq\",\"403.2d3096d4.js\",\"d4iKu\",\"calendar.8ac659bd.json\",\"9aINQ\",\"hashcache.7defbf8b.json\"]"));

function $b32efe327c8459fb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $b32efe327c8459fb$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $b32efe327c8459fb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $b32efe327c8459fb$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $ef3a86602012e2c3$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $2ffd1edbe3502dec$var$extendStatics = function extendStatics1(d, b) {
    $2ffd1edbe3502dec$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2ffd1edbe3502dec$var$extendStatics(d, b);
};
function $2ffd1edbe3502dec$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2ffd1edbe3502dec$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2ffd1edbe3502dec$export$18ce0697a983be9b = function __assign1() {
    $2ffd1edbe3502dec$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2ffd1edbe3502dec$export$18ce0697a983be9b.apply(this, arguments);
};
function $2ffd1edbe3502dec$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2ffd1edbe3502dec$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2ffd1edbe3502dec$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2ffd1edbe3502dec$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $2ffd1edbe3502dec$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $2ffd1edbe3502dec$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $2ffd1edbe3502dec$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $2ffd1edbe3502dec$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2ffd1edbe3502dec$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2ffd1edbe3502dec$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $2ffd1edbe3502dec$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $2ffd1edbe3502dec$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $2ffd1edbe3502dec$export$45d3717a4c69092e(o, m, p);
}
function $2ffd1edbe3502dec$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2ffd1edbe3502dec$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2ffd1edbe3502dec$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2ffd1edbe3502dec$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2ffd1edbe3502dec$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2ffd1edbe3502dec$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $2ffd1edbe3502dec$export$10c90e4f7922046c(v) {
    return this instanceof $2ffd1edbe3502dec$export$10c90e4f7922046c ? (this.v = v, this) : new $2ffd1edbe3502dec$export$10c90e4f7922046c(v);
}
function $2ffd1edbe3502dec$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2ffd1edbe3502dec$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2ffd1edbe3502dec$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2ffd1edbe3502dec$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $2ffd1edbe3502dec$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2ffd1edbe3502dec$export$19a8beecd37a4c45 === "function" ? $2ffd1edbe3502dec$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2ffd1edbe3502dec$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $2ffd1edbe3502dec$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $2ffd1edbe3502dec$var$ownKeys = function ownKeys1(o) {
    $2ffd1edbe3502dec$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $2ffd1edbe3502dec$var$ownKeys(o);
};
function $2ffd1edbe3502dec$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $2ffd1edbe3502dec$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $2ffd1edbe3502dec$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $2ffd1edbe3502dec$var$__setModuleDefault(result, mod);
    return result;
}
function $2ffd1edbe3502dec$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2ffd1edbe3502dec$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $2ffd1edbe3502dec$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $2ffd1edbe3502dec$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $2ffd1edbe3502dec$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $2ffd1edbe3502dec$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $2ffd1edbe3502dec$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $2ffd1edbe3502dec$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $2ffd1edbe3502dec$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $2ffd1edbe3502dec$export$2e2bcd8739ae039 = {
    __extends: $2ffd1edbe3502dec$export$a8ba968b8961cb8a,
    __assign: $2ffd1edbe3502dec$export$18ce0697a983be9b,
    __rest: $2ffd1edbe3502dec$export$3c9a16f847548506,
    __decorate: $2ffd1edbe3502dec$export$29e00dfd3077644b,
    __param: $2ffd1edbe3502dec$export$d5ad3fd78186038f,
    __esDecorate: $2ffd1edbe3502dec$export$3a84e1ae4e97e9b0,
    __runInitializers: $2ffd1edbe3502dec$export$d831c04e792af3d,
    __propKey: $2ffd1edbe3502dec$export$6a2a36740a146cb8,
    __setFunctionName: $2ffd1edbe3502dec$export$d1a06452d3489bc7,
    __metadata: $2ffd1edbe3502dec$export$f1db080c865becb9,
    __awaiter: $2ffd1edbe3502dec$export$1050f835b63b671e,
    __generator: $2ffd1edbe3502dec$export$67ebef60e6f28a6,
    __createBinding: $2ffd1edbe3502dec$export$45d3717a4c69092e,
    __exportStar: $2ffd1edbe3502dec$export$f33643c0debef087,
    __values: $2ffd1edbe3502dec$export$19a8beecd37a4c45,
    __read: $2ffd1edbe3502dec$export$8d051b38c9118094,
    __spread: $2ffd1edbe3502dec$export$afc72e2116322959,
    __spreadArrays: $2ffd1edbe3502dec$export$6388937ca91ccae8,
    __spreadArray: $2ffd1edbe3502dec$export$1216008129fb82ed,
    __await: $2ffd1edbe3502dec$export$10c90e4f7922046c,
    __asyncGenerator: $2ffd1edbe3502dec$export$e427f37a30a4de9b,
    __asyncDelegator: $2ffd1edbe3502dec$export$bbd80228419bb833,
    __asyncValues: $2ffd1edbe3502dec$export$e3b29a3d6162315f,
    __makeTemplateObject: $2ffd1edbe3502dec$export$4fb47efe1390b86f,
    __importStar: $2ffd1edbe3502dec$export$c21735bcef00d192,
    __importDefault: $2ffd1edbe3502dec$export$da59b14a69baef04,
    __classPrivateFieldGet: $2ffd1edbe3502dec$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $2ffd1edbe3502dec$export$d40a35129aaff81f,
    __classPrivateFieldIn: $2ffd1edbe3502dec$export$81fdc39f203e4e04,
    __addDisposableResource: $2ffd1edbe3502dec$export$88ac25d8e944e405,
    __disposeResources: $2ffd1edbe3502dec$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $2ffd1edbe3502dec$export$889dfb5d17574b0b
};


function $54267f30d2ea9aae$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $a3a3daa8a7dc7bad$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $54267f30d2ea9aae$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $263b86e2fd0c19cc$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $65e85fa008cbe4b5$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $177719b8b89fcd85$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $4603803873b17a00$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $926341d255c29ca9$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $4603803873b17a00$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $4603803873b17a00$export$71511d61b312f219)(o, minLen);
}


function $ab93484eb739fb64$export$71511d61b312f219(arr, i) {
    return (0, $263b86e2fd0c19cc$export$71511d61b312f219)(arr) || (0, $65e85fa008cbe4b5$export$71511d61b312f219)(arr, i) || (0, $926341d255c29ca9$export$71511d61b312f219)(arr, i) || (0, $177719b8b89fcd85$export$71511d61b312f219)();
}


var $161ef0eada468d00$export$f2120bbfa5450bd2 = function(collapse, year) {
    return '<svg class="news-arrow'.concat(collapse, '" id="news-arrow-').concat(year, '" xmlns="http://www.w3.org/2000/svg" viewBox="0 -1.5 16 16"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg>');
};
var $161ef0eada468d00$export$a80b3bd66acc52ff = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/></svg>';


var $f065ff54a2e0bbce$exports = {};
$f065ff54a2e0bbce$exports = JSON.parse("{\"New Year's Day\":{\"isHoliday\":true,\"dates\":{\"2024-12-31\":\"9 AM - 4:30 PM\",\"2025-01-01\":\"CLOSED\"}},\"President's Day\":{\"isHoliday\":true,\"dates\":{\"2025-02-17\":\"CLOSED\"}},\"Good Friday\":{\"isHoliday\":true,\"dates\":{\"2025-04-18\":\"CLOSED\"}},\"Memorial Day\":{\"isHoliday\":true,\"dates\":{\"2025-05-26\":\"CLOSED\"}},\"Independence Day\":{\"isHoliday\":true,\"dates\":{\"2025-07-04\":\"CLOSED\"}},\"Labor Day\":{\"isHoliday\":true,\"dates\":{\"2025-09-01\":\"CLOSED\"}},\"Columbus Day\":{\"isHoliday\":true,\"dates\":{\"2025-10-13\":\"CLOSED\"}},\"Veterans' Day\":{\"isHoliday\":true,\"dates\":{\"2025-11-11\":\"CLOSED\"}},\"Thanksgiving\":{\"isHoliday\":true,\"dates\":{\"2025-11-26\":\"9 AM - 4:30 PM\",\"2025-11-27\":\"CLOSED\",\"2025-11-28\":\"CLOSED\"}},\"Christmas\":{\"isHoliday\":true,\"dates\":{\"2025-12-23\":\"9 AM - 4:30 PM\",\"2025-12-24\":\"CLOSED\",\"2025-12-25\":\"CLOSED\"}}}");


"use strict";


var $461264eed7066dae$export$461939dd4422153 = new Date("March 10 2025");
var $461264eed7066dae$export$89ae9bee9fce960e = $461264eed7066dae$export$461939dd4422153.getDay();
var $461264eed7066dae$export$44a7792e638edf8c = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var $461264eed7066dae$export$a038b291f736c35e = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $461264eed7066dae$export$b7f7efbe9ab39b25 = function(t) {
    return $461264eed7066dae$export$44a7792e638edf8c[t.getDay()];
};
var $461264eed7066dae$export$651581c3ee2374b0 = function(t) {
    return "".concat($461264eed7066dae$export$b7f7efbe9ab39b25(t).slice(0, 3), ".");
};
var $461264eed7066dae$export$af5de1609f06c8e6 = function(t) {
    return $461264eed7066dae$export$a038b291f736c35e[t.getMonth()];
};
var $461264eed7066dae$export$c89bec1a34a35e6c = function(t) {
    return "".concat($461264eed7066dae$export$af5de1609f06c8e6(t).slice(0, 3), ".");
};
var $461264eed7066dae$export$371ef0f33bdee71f = 36e5;
var $461264eed7066dae$export$bb84506e5188b5b1 = $461264eed7066dae$export$371ef0f33bdee71f * 24;
var $461264eed7066dae$export$4a4306ad4fa0e5e6 = function(d, h) {
    return new Date(d.getTime() + h * $461264eed7066dae$export$371ef0f33bdee71f);
};
var $461264eed7066dae$export$dd412b56f1e4d8aa = function(d, dd) {
    return new Date(d.getTime() + dd * $461264eed7066dae$export$bb84506e5188b5b1);
};
var $461264eed7066dae$export$3ae94a2503e890a1 = function(n) {
    n = n.getDate();
    return n % 10 === 1 && n != 11 ? "".concat(n, "st") : n % 10 === 2 && n != 12 ? "".concat(n, "nd") : n % 10 === 3 && n != 13 ? "".concat(n, "rd") : "".concat(n, "th");
};
var $461264eed7066dae$export$3203edd9e5edd663 = function(d) {
    var hh = d.getHours();
    var m = d.getMinutes().toString().padStart(2, 0);
    var dd = hh >= 12 ? "PM" : "AM";
    var h = hh >= 12 ? hh - 12 : hh;
    h = h === 0 ? h = 12 : h;
    return "".concat(h, ":").concat(m, " ").concat(dd);
};
var $461264eed7066dae$export$78a7e49ccc71dc8c = function(date) {
    return date.toISOString().replace(/\d+Z/, 'Z').replaceAll(/[^\dTZ]+/g, '');
};
var $461264eed7066dae$export$eb66d2f1c11e30bf = function(t) {
    return "".concat($461264eed7066dae$export$af5de1609f06c8e6(t), " ").concat($461264eed7066dae$export$3ae94a2503e890a1(t));
};
var $461264eed7066dae$export$26e685d98fdeb12f = function(t) {
    return "".concat($461264eed7066dae$export$651581c3ee2374b0(t), " ").concat($461264eed7066dae$export$af5de1609f06c8e6(t), " ").concat(t.getDate());
};
var $461264eed7066dae$export$9a60ba5ad633d9c0 = function(t) {
    return "".concat($461264eed7066dae$export$b7f7efbe9ab39b25(t), ", ").concat($461264eed7066dae$export$eb66d2f1c11e30bf(t));
};
var $461264eed7066dae$export$b3abad897351349f = function(arr) {
    var splitter = [
        0
    ];
    for(var i = 1; i < arr.length; i++)if (arr[i].getMonth() !== arr[i - 1].getMonth()) splitter.push(i);
    splitter.push(arr.length);
    var output = [];
    var datestr;
    for(var i1 = 0; i1 < splitter.length - 1; i1++){
        datestr = "".concat($461264eed7066dae$export$af5de1609f06c8e6(arr[splitter[i1]]), " ");
        for(var j = splitter[i1]; j < splitter[i1 + 1]; j++){
            datestr += $461264eed7066dae$export$3ae94a2503e890a1(arr[j]);
            if (j < splitter[i1 + 1] - 1) datestr += ", ";
        }
        output.push(datestr);
    }
    return output;
};
var $461264eed7066dae$export$813e98560751a081 = function() {
    // Prune expired alerts
    var alerts = document.getElementById("alerts");
    if (alerts) {
        var alertList = Array.from(alerts.children);
        var activeAlerts = "";
        alertList.forEach(function(alert) {
            var expiryTag = alert.dataset.expires;
            if (expiryTag === "" || expiryTag === undefined) activeAlerts += alert.outerHTML;
            else {
                var expiry = expiryTag.includes(":") ? new Date(expiryTag) : new Date("".concat(expiryTag, " 8:00 PM"));
                if (expiry > $461264eed7066dae$export$461939dd4422153.getTime()) activeAlerts += alert.outerHTML;
            }
        });
        alerts.innerHTML = activeAlerts;
    }
    // Holiday alerts
    var holidayKeys = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($f065ff54a2e0bbce$exports))));
    holidayKeys.forEach(function(holiday) {
        var isHoliday = (0, (/*@__PURE__*/$parcel$interopDefault($f065ff54a2e0bbce$exports)))[holiday].isHoliday;
        var holidayDates = (0, (/*@__PURE__*/$parcel$interopDefault($f065ff54a2e0bbce$exports)))[holiday].dates;
        var dateKeys = Object.keys(holidayDates);
        // Get closing days
        var closings = dateKeys.filter(function(x) {
            return holidayDates[x] === 'CLOSED';
        });
        // Get modified schedules
        var modDates = (0, $a3a3daa8a7dc7bad$export$71511d61b312f219)({}, holidayDates);
        Object.keys(modDates).forEach(function(x) {
            if (closings.includes(x)) delete modDates[x];
        });
        // Prepare alert string (closings)
        var closeStr, modStr;
        if (closings.length > 0) {
            var closeStart = $461264eed7066dae$export$4a4306ad4fa0e5e6(new Date(closings[0]), 5);
            var closeEnd = $461264eed7066dae$export$4a4306ad4fa0e5e6(new Date(closings[closings.length - 1]), 29);
            var closeEndName = $461264eed7066dae$export$4a4306ad4fa0e5e6(new Date(closeEnd), -24);
            closeStr = "be closed ".concat(closings.length > 1 ? "from <b>".concat($461264eed7066dae$export$9a60ba5ad633d9c0(closeStart), "</b> to <b>").concat($461264eed7066dae$export$9a60ba5ad633d9c0(closeEndName), "</b>") : "on <b>".concat($461264eed7066dae$export$9a60ba5ad633d9c0(closeStart), "</b>"));
        }
        // Prepare alert string (delays/early closings)
        // Handles only one modified schedule for now.
        if (Object.keys(modDates).length > 0) {
            var modKey = Object.keys(modDates)[0];
            var modDay = $461264eed7066dae$export$4a4306ad4fa0e5e6(new Date(modKey), 5);
            var _modDates_modKey_split = (0, $ab93484eb739fb64$export$71511d61b312f219)(modDates[modKey].split(' - '), 2), modOpen = _modDates_modKey_split[0], modClose = _modDates_modKey_split[1];
            modStr = "".concat(modOpen !== '9 AM' ? "open at <b>".concat(modOpen) : "close at <b>".concat(modClose), "</b> on <b>").concat($461264eed7066dae$export$9a60ba5ad633d9c0(modDay), "</b>");
        }
        // Concat + inject string
        var holidayStart = $461264eed7066dae$export$4a4306ad4fa0e5e6(new Date(dateKeys[0]), 5);
        var holidayEnd = $461264eed7066dae$export$4a4306ad4fa0e5e6(new Date(dateKeys[dateKeys.length - 1]), -24);
        if (alerts && holidayStart.getTime() - $461264eed7066dae$export$461939dd4422153.getTime() <= $461264eed7066dae$export$bb84506e5188b5b1 * 14 && holidayEnd.getTime() - $461264eed7066dae$export$461939dd4422153.getTime() > 0) alerts.innerHTML = "".concat(alerts.innerHTML, '\n            <div class="alert-info">\n                ').concat($161ef0eada468d00$export$a80b3bd66acc52ff, "\n                <span>Raritan Public Library will ").concat(closeStr ? closeStr : modStr, " ").concat(isHoliday ? 'in observance of' : 'for', " <b>").concat(holiday, "</b>. ").concat(modStr ? "The Library will also ".concat(modStr, ".") : "", "</span>\n            </div>");
    });
};


// Generate a request and response using a url and handling function


var $f6be3119d5b3e79b$export$f46232c2a9c34923 = /*#__PURE__*/ function() {
    var _ref = (0, $b32efe327c8459fb$export$71511d61b312f219)(function(url, resFunc) {
        return (0, $2ffd1edbe3502dec$export$67ebef60e6f28a6)(this, function(_state) {
            fetch(url).then(function(response) {
                return response.json();
            }).then(function(data) {
                return resFunc(data);
            }).catch(function(err) {
                return console.log(err);
            });
            return [
                2
            ];
        });
    });
    return function req(url, resFunc) {
        return _ref.apply(this, arguments);
    };
}();
var $f6be3119d5b3e79b$export$842a2cf37af977e1 = function(n, m) {
    return (n % m + m) % m;
};
var $f6be3119d5b3e79b$export$5dc35a59ea5345f7 = function(str) {
    return str.match('^http') ? 'rel="noopener"' : "";
};
var $f6be3119d5b3e79b$export$d59f2f0b5faf7876 = function(addCondition, removeCondition) {
    for(var _len = arguments.length, pairs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        pairs[_key - 2] = arguments[_key];
    }
    if (addCondition) pairs.forEach(function(pair) {
        return pair[0].classList.add(pair[1]);
    });
    else if (removeCondition) pairs.forEach(function(pair) {
        return pair[0].classList.remove(pair[1]);
    });
};
var $f6be3119d5b3e79b$export$187b105aa6466800 = function(func) {
    if (window.hasOwnProperty('ontouchstart')) window.addEventListener('touchstart', func);
    else window.addEventListener('click', func);
};
var $f6be3119d5b3e79b$export$3ae65339208f6100 = function(cat) {
    cat = cat.length === 1 ? cat[0].name : "";
    switch(cat){
        case "Holiday":
            return "crimson";
        case "Computers & Technology":
            return "red";
        case "Movie":
            return "orange";
        case "Health & Fitness":
            return "yellow";
        case "History":
            return "lime";
        case "ESL":
            return "green";
        case "Book Club":
            return "teal";
        case "Arts & Culture":
            return "cyan";
        case "Gaming":
            return "blue";
        case "Storytime":
            return "purple";
        case "Craft Program":
            return "pink";
        default:
            return "grey";
    }
};
var $f6be3119d5b3e79b$export$3c49c185de0c2bfc = function() {
    return Math.max(document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth);
};
var $f6be3119d5b3e79b$export$b141de964f0a90c1 = function(max) {
    return Math.floor(Math.random() * max) + 1;
};



// Get an object with some important properties
var $7f19431eca38d161$var$moreLinks = {
    "main": document.getElementById("more"),
    "sub": document.getElementById("more-content"),
    "arrow": document.querySelector("#more > svg")
};
// Conditional for clicking dropdowns
var $7f19431eca38d161$var$dropdownClickLogic = function(e) {
    $f6be3119d5b3e79b$export$d59f2f0b5faf7876($7f19431eca38d161$var$moreLinks.main.contains(e.target) && !$7f19431eca38d161$var$moreLinks.sub.classList.contains("more-links-down"), !$7f19431eca38d161$var$moreLinks.sub.contains(e.target) && $7f19431eca38d161$var$moreLinks.sub.classList.contains("more-links-down"), [
        $7f19431eca38d161$var$moreLinks.sub,
        "more-links-down"
    ], [
        $7f19431eca38d161$var$moreLinks.arrow,
        "rotate180"
    ]);
};
// Conditional for dropdowns via keyboard input
var $7f19431eca38d161$var$dropdownKeyLogic = function(tab, e) {
    $f6be3119d5b3e79b$export$d59f2f0b5faf7876(e.key === "Tab" && tab === "more" && !$7f19431eca38d161$var$moreLinks.sub.classList.contains("more-links-down"), e.key === "Tab" && tab !== "more" && $7f19431eca38d161$var$moreLinks.sub.classList.contains("more-links-down"), [
        $7f19431eca38d161$var$moreLinks.sub,
        "more-links-down"
    ], [
        $7f19431eca38d161$var$moreLinks.arrow,
        "rotate180"
    ]);
};
var $7f19431eca38d161$export$81207e5cc4186890 = function() {
    $f6be3119d5b3e79b$export$187b105aa6466800(function(e) {
        $7f19431eca38d161$var$dropdownClickLogic(e);
    });
    window.addEventListener('keyup', function(e) {
        var tabbed;
        try {
            tabbed = document.activeElement.id || document.activeElement.parentElement.parentElement.id;
        } catch (error) {
            tabbed = document.activeElement.id;
        }
        $7f19431eca38d161$var$dropdownKeyLogic(tabbed, e);
    });
};
var $7f19431eca38d161$export$4bd4b47501432316 = function() {
    var xDown = null;
    document.addEventListener('touchstart', function(e) {
        var firstTouch = e.touches[0];
        xDown = firstTouch.clientX;
    });
    document.addEventListener('touchmove', function(e) {
        if (!xDown) return;
        var xUp = e.touches[0].clientX;
        var xDiff = xDown - xUp;
        if (Math.abs(xDiff) > 10 && document.documentElement.scrollTop < 20) {
            var links = document.getElementById("links");
            var menuIcon = document.querySelector(".nav-toggle > svg");
            var main = document.querySelector(".main");
            var page = document.querySelector("html");
            $f6be3119d5b3e79b$export$d59f2f0b5faf7876(!menuIcon.classList.contains("enlarge") && xDiff > 0, menuIcon.classList.contains("enlarge") && xDiff < 0, [
                links,
                "links-open"
            ], [
                menuIcon,
                "enlarge"
            ], [
                main,
                "darken",
                "freeze"
            ], [
                page,
                "freeze"
            ]);
        }
        xDown = null;
    });
    $f6be3119d5b3e79b$export$187b105aa6466800(function(e) {
        var links = document.getElementById("links");
        var menu = document.getElementById("nav-toggle");
        var menuIcon = document.querySelector(".nav-toggle > svg");
        var main = document.querySelector(".main");
        var themeButton = document.getElementById("theme");
        var page = document.querySelector("html");
        $f6be3119d5b3e79b$export$d59f2f0b5faf7876(menu.contains(e.target) && !menuIcon.classList.contains("enlarge"), !links.contains(e.target) && menuIcon.classList.contains("enlarge"), [
            links,
            "links-open"
        ], [
            menuIcon,
            "enlarge"
        ], [
            main,
            "darken",
            "freeze"
        ], [
            themeButton,
            "theme-darken"
        ], [
            page,
            "freeze"
        ]);
    });
};





/*! js-yaml 4.1.0 https://github.com/nodeca/js-yaml @license MIT */ 
function $41a6607af35fbe66$var$isNothing(subject) {
    return typeof subject === 'undefined' || subject === null;
}
function $41a6607af35fbe66$var$isObject(subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(subject)) === 'object' && subject !== null;
}
function $41a6607af35fbe66$var$toArray(sequence) {
    if (Array.isArray(sequence)) return sequence;
    else if ($41a6607af35fbe66$var$isNothing(sequence)) return [];
    return [
        sequence
    ];
}
function $41a6607af35fbe66$var$extend(target, source) {
    var index, length, key, sourceKeys;
    if (source) {
        sourceKeys = Object.keys(source);
        for(index = 0, length = sourceKeys.length; index < length; index += 1){
            key = sourceKeys[index];
            target[key] = source[key];
        }
    }
    return target;
}
function $41a6607af35fbe66$var$repeat(string, count) {
    var result = '', cycle;
    for(cycle = 0; cycle < count; cycle += 1)result += string;
    return result;
}
function $41a6607af35fbe66$var$isNegativeZero(number) {
    return number === 0 && Number.NEGATIVE_INFINITY === 1 / number;
}
var $41a6607af35fbe66$var$isNothing_1 = $41a6607af35fbe66$var$isNothing;
var $41a6607af35fbe66$var$isObject_1 = $41a6607af35fbe66$var$isObject;
var $41a6607af35fbe66$var$toArray_1 = $41a6607af35fbe66$var$toArray;
var $41a6607af35fbe66$var$repeat_1 = $41a6607af35fbe66$var$repeat;
var $41a6607af35fbe66$var$isNegativeZero_1 = $41a6607af35fbe66$var$isNegativeZero;
var $41a6607af35fbe66$var$extend_1 = $41a6607af35fbe66$var$extend;
var $41a6607af35fbe66$var$common = {
    isNothing: $41a6607af35fbe66$var$isNothing_1,
    isObject: $41a6607af35fbe66$var$isObject_1,
    toArray: $41a6607af35fbe66$var$toArray_1,
    repeat: $41a6607af35fbe66$var$repeat_1,
    isNegativeZero: $41a6607af35fbe66$var$isNegativeZero_1,
    extend: $41a6607af35fbe66$var$extend_1
};
// YAML error class. http://stackoverflow.com/questions/8458984
function $41a6607af35fbe66$var$formatError(exception, compact) {
    var where = '', message = exception.reason || '(unknown reason)';
    if (!exception.mark) return message;
    if (exception.mark.name) where += 'in "' + exception.mark.name + '" ';
    where += '(' + (exception.mark.line + 1) + ':' + (exception.mark.column + 1) + ')';
    if (!compact && exception.mark.snippet) where += '\n\n' + exception.mark.snippet;
    return message + ' ' + where;
}
function $41a6607af35fbe66$var$YAMLException$1(reason, mark) {
    // Super constructor
    Error.call(this);
    this.name = 'YAMLException';
    this.reason = reason;
    this.mark = mark;
    this.message = $41a6607af35fbe66$var$formatError(this, false);
    // Include stack trace in error object
    if (Error.captureStackTrace) // Chrome and NodeJS
    Error.captureStackTrace(this, this.constructor);
    else // FF, IE 10+ and Safari 6+. Fallback for others
    this.stack = new Error().stack || '';
}
// Inherit from Error
$41a6607af35fbe66$var$YAMLException$1.prototype = Object.create(Error.prototype);
$41a6607af35fbe66$var$YAMLException$1.prototype.constructor = $41a6607af35fbe66$var$YAMLException$1;
$41a6607af35fbe66$var$YAMLException$1.prototype.toString = function toString(compact) {
    return this.name + ': ' + $41a6607af35fbe66$var$formatError(this, compact);
};
var $41a6607af35fbe66$var$exception = $41a6607af35fbe66$var$YAMLException$1;
// get snippet for a single line, respecting maxLength
function $41a6607af35fbe66$var$getLine(buffer, lineStart, lineEnd, position, maxLineLength) {
    var head = '';
    var tail = '';
    var maxHalfLength = Math.floor(maxLineLength / 2) - 1;
    if (position - lineStart > maxHalfLength) {
        head = ' ... ';
        lineStart = position - maxHalfLength + head.length;
    }
    if (lineEnd - position > maxHalfLength) {
        tail = ' ...';
        lineEnd = position + maxHalfLength - tail.length;
    }
    return {
        str: head + buffer.slice(lineStart, lineEnd).replace(/\t/g, "\u2192") + tail,
        pos: position - lineStart + head.length // relative position
    };
}
function $41a6607af35fbe66$var$padStart(string, max) {
    return $41a6607af35fbe66$var$common.repeat(' ', max - string.length) + string;
}
function $41a6607af35fbe66$var$makeSnippet(mark, options) {
    options = Object.create(options || null);
    if (!mark.buffer) return null;
    if (!options.maxLength) options.maxLength = 79;
    if (typeof options.indent !== 'number') options.indent = 1;
    if (typeof options.linesBefore !== 'number') options.linesBefore = 3;
    if (typeof options.linesAfter !== 'number') options.linesAfter = 2;
    var re = /\r?\n|\r|\0/g;
    var lineStarts = [
        0
    ];
    var lineEnds = [];
    var match;
    var foundLineNo = -1;
    while(match = re.exec(mark.buffer)){
        lineEnds.push(match.index);
        lineStarts.push(match.index + match[0].length);
        if (mark.position <= match.index && foundLineNo < 0) foundLineNo = lineStarts.length - 2;
    }
    if (foundLineNo < 0) foundLineNo = lineStarts.length - 1;
    var result = '', i, line;
    var lineNoLength = Math.min(mark.line + options.linesAfter, lineEnds.length).toString().length;
    var maxLineLength = options.maxLength - (options.indent + lineNoLength + 3);
    for(i = 1; i <= options.linesBefore; i++){
        if (foundLineNo - i < 0) break;
        line = $41a6607af35fbe66$var$getLine(mark.buffer, lineStarts[foundLineNo - i], lineEnds[foundLineNo - i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo - i]), maxLineLength);
        result = $41a6607af35fbe66$var$common.repeat(' ', options.indent) + $41a6607af35fbe66$var$padStart((mark.line - i + 1).toString(), lineNoLength) + ' | ' + line.str + '\n' + result;
    }
    line = $41a6607af35fbe66$var$getLine(mark.buffer, lineStarts[foundLineNo], lineEnds[foundLineNo], mark.position, maxLineLength);
    result += $41a6607af35fbe66$var$common.repeat(' ', options.indent) + $41a6607af35fbe66$var$padStart((mark.line + 1).toString(), lineNoLength) + ' | ' + line.str + '\n';
    result += $41a6607af35fbe66$var$common.repeat('-', options.indent + lineNoLength + 3 + line.pos) + '^' + '\n';
    for(i = 1; i <= options.linesAfter; i++){
        if (foundLineNo + i >= lineEnds.length) break;
        line = $41a6607af35fbe66$var$getLine(mark.buffer, lineStarts[foundLineNo + i], lineEnds[foundLineNo + i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo + i]), maxLineLength);
        result += $41a6607af35fbe66$var$common.repeat(' ', options.indent) + $41a6607af35fbe66$var$padStart((mark.line + i + 1).toString(), lineNoLength) + ' | ' + line.str + '\n';
    }
    return result.replace(/\n$/, '');
}
var $41a6607af35fbe66$var$snippet = $41a6607af35fbe66$var$makeSnippet;
var $41a6607af35fbe66$var$TYPE_CONSTRUCTOR_OPTIONS = [
    'kind',
    'multi',
    'resolve',
    'construct',
    'instanceOf',
    'predicate',
    'represent',
    'representName',
    'defaultStyle',
    'styleAliases'
];
var $41a6607af35fbe66$var$YAML_NODE_KINDS = [
    'scalar',
    'sequence',
    'mapping'
];
function $41a6607af35fbe66$var$compileStyleAliases(map) {
    var result = {};
    if (map !== null) Object.keys(map).forEach(function(style) {
        map[style].forEach(function(alias) {
            result[String(alias)] = style;
        });
    });
    return result;
}
function $41a6607af35fbe66$var$Type$1(tag, options) {
    options = options || {};
    Object.keys(options).forEach(function(name) {
        if ($41a6607af35fbe66$var$TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) throw new $41a6607af35fbe66$var$exception('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
    });
    // TODO: Add tag format check.
    this.options = options; // keep original options in case user wants to extend this type later
    this.tag = tag;
    this.kind = options['kind'] || null;
    this.resolve = options['resolve'] || function() {
        return true;
    };
    this.construct = options['construct'] || function(data) {
        return data;
    };
    this.instanceOf = options['instanceOf'] || null;
    this.predicate = options['predicate'] || null;
    this.represent = options['represent'] || null;
    this.representName = options['representName'] || null;
    this.defaultStyle = options['defaultStyle'] || null;
    this.multi = options['multi'] || false;
    this.styleAliases = $41a6607af35fbe66$var$compileStyleAliases(options['styleAliases'] || null);
    if ($41a6607af35fbe66$var$YAML_NODE_KINDS.indexOf(this.kind) === -1) throw new $41a6607af35fbe66$var$exception('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
}
var $41a6607af35fbe66$var$type = $41a6607af35fbe66$var$Type$1;
/*eslint-disable max-len*/ function $41a6607af35fbe66$var$compileList(schema, name) {
    var result = [];
    schema[name].forEach(function(currentType) {
        var newIndex = result.length;
        result.forEach(function(previousType, previousIndex) {
            if (previousType.tag === currentType.tag && previousType.kind === currentType.kind && previousType.multi === currentType.multi) newIndex = previousIndex;
        });
        result[newIndex] = currentType;
    });
    return result;
}
function $41a6607af35fbe66$var$compileMap() {
    var result = {
        scalar: {},
        sequence: {},
        mapping: {},
        fallback: {},
        multi: {
            scalar: [],
            sequence: [],
            mapping: [],
            fallback: []
        }
    }, index, length;
    function collectType(type) {
        if (type.multi) {
            result.multi[type.kind].push(type);
            result.multi['fallback'].push(type);
        } else result[type.kind][type.tag] = result['fallback'][type.tag] = type;
    }
    for(index = 0, length = arguments.length; index < length; index += 1)arguments[index].forEach(collectType);
    return result;
}
function $41a6607af35fbe66$var$Schema$1(definition) {
    return this.extend(definition);
}
$41a6607af35fbe66$var$Schema$1.prototype.extend = function extend(definition) {
    var implicit = [];
    var explicit = [];
    if (definition instanceof $41a6607af35fbe66$var$type) // Schema.extend(type)
    explicit.push(definition);
    else if (Array.isArray(definition)) // Schema.extend([ type1, type2, ... ])
    explicit = explicit.concat(definition);
    else if (definition && (Array.isArray(definition.implicit) || Array.isArray(definition.explicit))) {
        // Schema.extend({ explicit: [ type1, type2, ... ], implicit: [ type1, type2, ... ] })
        if (definition.implicit) implicit = implicit.concat(definition.implicit);
        if (definition.explicit) explicit = explicit.concat(definition.explicit);
    } else throw new $41a6607af35fbe66$var$exception("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");
    implicit.forEach(function(type$1) {
        if (!(type$1 instanceof $41a6607af35fbe66$var$type)) throw new $41a6607af35fbe66$var$exception('Specified list of YAML types (or a single Type object) contains a non-Type object.');
        if (type$1.loadKind && type$1.loadKind !== 'scalar') throw new $41a6607af35fbe66$var$exception('There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.');
        if (type$1.multi) throw new $41a6607af35fbe66$var$exception('There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.');
    });
    explicit.forEach(function(type$1) {
        if (!(type$1 instanceof $41a6607af35fbe66$var$type)) throw new $41a6607af35fbe66$var$exception('Specified list of YAML types (or a single Type object) contains a non-Type object.');
    });
    var result = Object.create($41a6607af35fbe66$var$Schema$1.prototype);
    result.implicit = (this.implicit || []).concat(implicit);
    result.explicit = (this.explicit || []).concat(explicit);
    result.compiledImplicit = $41a6607af35fbe66$var$compileList(result, 'implicit');
    result.compiledExplicit = $41a6607af35fbe66$var$compileList(result, 'explicit');
    result.compiledTypeMap = $41a6607af35fbe66$var$compileMap(result.compiledImplicit, result.compiledExplicit);
    return result;
};
var $41a6607af35fbe66$var$schema = $41a6607af35fbe66$var$Schema$1;
var $41a6607af35fbe66$var$str = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:str', {
    kind: 'scalar',
    construct: function construct(data) {
        return data !== null ? data : '';
    }
});
var $41a6607af35fbe66$var$seq = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:seq', {
    kind: 'sequence',
    construct: function construct(data) {
        return data !== null ? data : [];
    }
});
var $41a6607af35fbe66$var$map = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:map', {
    kind: 'mapping',
    construct: function construct(data) {
        return data !== null ? data : {};
    }
});
var $41a6607af35fbe66$var$failsafe = new $41a6607af35fbe66$var$schema({
    explicit: [
        $41a6607af35fbe66$var$str,
        $41a6607af35fbe66$var$seq,
        $41a6607af35fbe66$var$map
    ]
});
function $41a6607af35fbe66$var$resolveYamlNull(data) {
    if (data === null) return true;
    var max = data.length;
    return max === 1 && data === '~' || max === 4 && (data === 'null' || data === 'Null' || data === 'NULL');
}
function $41a6607af35fbe66$var$constructYamlNull() {
    return null;
}
function $41a6607af35fbe66$var$isNull(object) {
    return object === null;
}
var $41a6607af35fbe66$var$_null = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:null', {
    kind: 'scalar',
    resolve: $41a6607af35fbe66$var$resolveYamlNull,
    construct: $41a6607af35fbe66$var$constructYamlNull,
    predicate: $41a6607af35fbe66$var$isNull,
    represent: {
        canonical: function canonical() {
            return '~';
        },
        lowercase: function lowercase() {
            return 'null';
        },
        uppercase: function uppercase() {
            return 'NULL';
        },
        camelcase: function camelcase() {
            return 'Null';
        },
        empty: function empty() {
            return '';
        }
    },
    defaultStyle: 'lowercase'
});
function $41a6607af35fbe66$var$resolveYamlBoolean(data) {
    if (data === null) return false;
    var max = data.length;
    return max === 4 && (data === 'true' || data === 'True' || data === 'TRUE') || max === 5 && (data === 'false' || data === 'False' || data === 'FALSE');
}
function $41a6607af35fbe66$var$constructYamlBoolean(data) {
    return data === 'true' || data === 'True' || data === 'TRUE';
}
function $41a6607af35fbe66$var$isBoolean(object) {
    return Object.prototype.toString.call(object) === '[object Boolean]';
}
var $41a6607af35fbe66$var$bool = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:bool', {
    kind: 'scalar',
    resolve: $41a6607af35fbe66$var$resolveYamlBoolean,
    construct: $41a6607af35fbe66$var$constructYamlBoolean,
    predicate: $41a6607af35fbe66$var$isBoolean,
    represent: {
        lowercase: function lowercase(object) {
            return object ? 'true' : 'false';
        },
        uppercase: function uppercase(object) {
            return object ? 'TRUE' : 'FALSE';
        },
        camelcase: function camelcase(object) {
            return object ? 'True' : 'False';
        }
    },
    defaultStyle: 'lowercase'
});
function $41a6607af35fbe66$var$isHexCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */  || 0x41 /* A */  <= c && c <= 0x46 /* F */  || 0x61 /* a */  <= c && c <= 0x66 /* f */ ;
}
function $41a6607af35fbe66$var$isOctCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x37 /* 7 */ ;
}
function $41a6607af35fbe66$var$isDecCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ;
}
function $41a6607af35fbe66$var$resolveYamlInteger(data) {
    if (data === null) return false;
    var max = data.length, index = 0, hasDigits = false, ch;
    if (!max) return false;
    ch = data[index];
    // sign
    if (ch === '-' || ch === '+') ch = data[++index];
    if (ch === '0') {
        // 0
        if (index + 1 === max) return true;
        ch = data[++index];
        // base 2, base 8, base 16
        if (ch === 'b') {
            // base 2
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (ch !== '0' && ch !== '1') return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
        if (ch === 'x') {
            // base 16
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (!$41a6607af35fbe66$var$isHexCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
        if (ch === 'o') {
            // base 8
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (!$41a6607af35fbe66$var$isOctCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
    }
    // base 10 (except 0)
    // value should not start with `_`;
    if (ch === '_') return false;
    for(; index < max; index++){
        ch = data[index];
        if (ch === '_') continue;
        if (!$41a6607af35fbe66$var$isDecCode(data.charCodeAt(index))) return false;
        hasDigits = true;
    }
    // Should have digits and should not end with `_`
    if (!hasDigits || ch === '_') return false;
    return true;
}
function $41a6607af35fbe66$var$constructYamlInteger(data) {
    var value = data, sign = 1, ch;
    if (value.indexOf('_') !== -1) value = value.replace(/_/g, '');
    ch = value[0];
    if (ch === '-' || ch === '+') {
        if (ch === '-') sign = -1;
        value = value.slice(1);
        ch = value[0];
    }
    if (value === '0') return 0;
    if (ch === '0') {
        if (value[1] === 'b') return sign * parseInt(value.slice(2), 2);
        if (value[1] === 'x') return sign * parseInt(value.slice(2), 16);
        if (value[1] === 'o') return sign * parseInt(value.slice(2), 8);
    }
    return sign * parseInt(value, 10);
}
function $41a6607af35fbe66$var$isInteger(object) {
    return Object.prototype.toString.call(object) === '[object Number]' && object % 1 === 0 && !$41a6607af35fbe66$var$common.isNegativeZero(object);
}
var $41a6607af35fbe66$var$int = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:int', {
    kind: 'scalar',
    resolve: $41a6607af35fbe66$var$resolveYamlInteger,
    construct: $41a6607af35fbe66$var$constructYamlInteger,
    predicate: $41a6607af35fbe66$var$isInteger,
    represent: {
        binary: function binary(obj) {
            return obj >= 0 ? '0b' + obj.toString(2) : '-0b' + obj.toString(2).slice(1);
        },
        octal: function octal(obj) {
            return obj >= 0 ? '0o' + obj.toString(8) : '-0o' + obj.toString(8).slice(1);
        },
        decimal: function decimal(obj) {
            return obj.toString(10);
        },
        /* eslint-disable max-len */ hexadecimal: function hexadecimal(obj) {
            return obj >= 0 ? '0x' + obj.toString(16).toUpperCase() : '-0x' + obj.toString(16).toUpperCase().slice(1);
        }
    },
    defaultStyle: 'decimal',
    styleAliases: {
        binary: [
            2,
            'bin'
        ],
        octal: [
            8,
            'oct'
        ],
        decimal: [
            10,
            'dec'
        ],
        hexadecimal: [
            16,
            'hex'
        ]
    }
});
var $41a6607af35fbe66$var$YAML_FLOAT_PATTERN = new RegExp(// 2.5e4, 2.5 and integers
"^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
function $41a6607af35fbe66$var$resolveYamlFloat(data) {
    if (data === null) return false;
    if (!$41a6607af35fbe66$var$YAML_FLOAT_PATTERN.test(data) || // Quick hack to not allow integers end with `_`
    // Probably should update regexp & check speed
    data[data.length - 1] === '_') return false;
    return true;
}
function $41a6607af35fbe66$var$constructYamlFloat(data) {
    var value, sign;
    value = data.replace(/_/g, '').toLowerCase();
    sign = value[0] === '-' ? -1 : 1;
    if ('+-'.indexOf(value[0]) >= 0) value = value.slice(1);
    if (value === '.inf') return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
    else if (value === '.nan') return NaN;
    return sign * parseFloat(value, 10);
}
var $41a6607af35fbe66$var$SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
function $41a6607af35fbe66$var$representYamlFloat(object, style) {
    var res;
    if (isNaN(object)) switch(style){
        case 'lowercase':
            return '.nan';
        case 'uppercase':
            return '.NAN';
        case 'camelcase':
            return '.NaN';
    }
    else if (Number.POSITIVE_INFINITY === object) switch(style){
        case 'lowercase':
            return '.inf';
        case 'uppercase':
            return '.INF';
        case 'camelcase':
            return '.Inf';
    }
    else if (Number.NEGATIVE_INFINITY === object) switch(style){
        case 'lowercase':
            return '-.inf';
        case 'uppercase':
            return '-.INF';
        case 'camelcase':
            return '-.Inf';
    }
    else if ($41a6607af35fbe66$var$common.isNegativeZero(object)) return '-0.0';
    res = object.toString(10);
    // JS stringifier can build scientific format without dots: 5e-100,
    // while YAML requres dot: 5.e-100. Fix it with simple hack
    return $41a6607af35fbe66$var$SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace('e', '.e') : res;
}
function $41a6607af35fbe66$var$isFloat(object) {
    return Object.prototype.toString.call(object) === '[object Number]' && (object % 1 !== 0 || $41a6607af35fbe66$var$common.isNegativeZero(object));
}
var $41a6607af35fbe66$var$float = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:float', {
    kind: 'scalar',
    resolve: $41a6607af35fbe66$var$resolveYamlFloat,
    construct: $41a6607af35fbe66$var$constructYamlFloat,
    predicate: $41a6607af35fbe66$var$isFloat,
    represent: $41a6607af35fbe66$var$representYamlFloat,
    defaultStyle: 'lowercase'
});
var $41a6607af35fbe66$var$json = $41a6607af35fbe66$var$failsafe.extend({
    implicit: [
        $41a6607af35fbe66$var$_null,
        $41a6607af35fbe66$var$bool,
        $41a6607af35fbe66$var$int,
        $41a6607af35fbe66$var$float
    ]
});
var $41a6607af35fbe66$var$core = $41a6607af35fbe66$var$json;
var $41a6607af35fbe66$var$YAML_DATE_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"); // [3] day
var $41a6607af35fbe66$var$YAML_TIMESTAMP_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$"); // [11] tz_minute
function $41a6607af35fbe66$var$resolveYamlTimestamp(data) {
    if (data === null) return false;
    if ($41a6607af35fbe66$var$YAML_DATE_REGEXP.exec(data) !== null) return true;
    if ($41a6607af35fbe66$var$YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
    return false;
}
function $41a6607af35fbe66$var$constructYamlTimestamp(data) {
    var match, year, month, day, hour, minute, second, fraction = 0, delta = null, tz_hour, tz_minute, date;
    match = $41a6607af35fbe66$var$YAML_DATE_REGEXP.exec(data);
    if (match === null) match = $41a6607af35fbe66$var$YAML_TIMESTAMP_REGEXP.exec(data);
    if (match === null) throw new Error('Date resolve error');
    // match: [1] year [2] month [3] day
    year = +match[1];
    month = +match[2] - 1; // JS month starts with 0
    day = +match[3];
    if (!match[4]) return new Date(Date.UTC(year, month, day));
    // match: [4] hour [5] minute [6] second [7] fraction
    hour = +match[4];
    minute = +match[5];
    second = +match[6];
    if (match[7]) {
        fraction = match[7].slice(0, 3);
        while(fraction.length < 3)fraction += '0';
        fraction = +fraction;
    }
    // match: [8] tz [9] tz_sign [10] tz_hour [11] tz_minute
    if (match[9]) {
        tz_hour = +match[10];
        tz_minute = +(match[11] || 0);
        delta = (tz_hour * 60 + tz_minute) * 60000; // delta in mili-seconds
        if (match[9] === '-') delta = -delta;
    }
    date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));
    if (delta) date.setTime(date.getTime() - delta);
    return date;
}
function $41a6607af35fbe66$var$representYamlTimestamp(object /*, style*/ ) {
    return object.toISOString();
}
var $41a6607af35fbe66$var$timestamp = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:timestamp', {
    kind: 'scalar',
    resolve: $41a6607af35fbe66$var$resolveYamlTimestamp,
    construct: $41a6607af35fbe66$var$constructYamlTimestamp,
    instanceOf: Date,
    represent: $41a6607af35fbe66$var$representYamlTimestamp
});
function $41a6607af35fbe66$var$resolveYamlMerge(data) {
    return data === '<<' || data === null;
}
var $41a6607af35fbe66$var$merge = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:merge', {
    kind: 'scalar',
    resolve: $41a6607af35fbe66$var$resolveYamlMerge
});
/*eslint-disable no-bitwise*/ // [ 64, 65, 66 ] -> [ padding, CR, LF ]
var $41a6607af35fbe66$var$BASE64_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r';
function $41a6607af35fbe66$var$resolveYamlBinary(data) {
    if (data === null) return false;
    var code, idx, bitlen = 0, max = data.length, map = $41a6607af35fbe66$var$BASE64_MAP;
    // Convert one by one.
    for(idx = 0; idx < max; idx++){
        code = map.indexOf(data.charAt(idx));
        // Skip CR/LF
        if (code > 64) continue;
        // Fail on illegal characters
        if (code < 0) return false;
        bitlen += 6;
    }
    // If there are any bits left, source was corrupted
    return bitlen % 8 === 0;
}
function $41a6607af35fbe66$var$constructYamlBinary(data) {
    var idx, tailbits, input = data.replace(/[\r\n=]/g, ''), max = input.length, map = $41a6607af35fbe66$var$BASE64_MAP, bits = 0, result = [];
    // Collect by 6*4 bits (3 bytes)
    for(idx = 0; idx < max; idx++){
        if (idx % 4 === 0 && idx) {
            result.push(bits >> 16 & 0xFF);
            result.push(bits >> 8 & 0xFF);
            result.push(bits & 0xFF);
        }
        bits = bits << 6 | map.indexOf(input.charAt(idx));
    }
    // Dump tail
    tailbits = max % 4 * 6;
    if (tailbits === 0) {
        result.push(bits >> 16 & 0xFF);
        result.push(bits >> 8 & 0xFF);
        result.push(bits & 0xFF);
    } else if (tailbits === 18) {
        result.push(bits >> 10 & 0xFF);
        result.push(bits >> 2 & 0xFF);
    } else if (tailbits === 12) result.push(bits >> 4 & 0xFF);
    return new Uint8Array(result);
}
function $41a6607af35fbe66$var$representYamlBinary(object /*, style*/ ) {
    var result = '', bits = 0, idx, tail, max = object.length, map = $41a6607af35fbe66$var$BASE64_MAP;
    // Convert every three bytes to 4 ASCII characters.
    for(idx = 0; idx < max; idx++){
        if (idx % 3 === 0 && idx) {
            result += map[bits >> 18 & 0x3F];
            result += map[bits >> 12 & 0x3F];
            result += map[bits >> 6 & 0x3F];
            result += map[bits & 0x3F];
        }
        bits = (bits << 8) + object[idx];
    }
    // Dump tail
    tail = max % 3;
    if (tail === 0) {
        result += map[bits >> 18 & 0x3F];
        result += map[bits >> 12 & 0x3F];
        result += map[bits >> 6 & 0x3F];
        result += map[bits & 0x3F];
    } else if (tail === 2) {
        result += map[bits >> 10 & 0x3F];
        result += map[bits >> 4 & 0x3F];
        result += map[bits << 2 & 0x3F];
        result += map[64];
    } else if (tail === 1) {
        result += map[bits >> 2 & 0x3F];
        result += map[bits << 4 & 0x3F];
        result += map[64];
        result += map[64];
    }
    return result;
}
function $41a6607af35fbe66$var$isBinary(obj) {
    return Object.prototype.toString.call(obj) === '[object Uint8Array]';
}
var $41a6607af35fbe66$var$binary = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:binary', {
    kind: 'scalar',
    resolve: $41a6607af35fbe66$var$resolveYamlBinary,
    construct: $41a6607af35fbe66$var$constructYamlBinary,
    predicate: $41a6607af35fbe66$var$isBinary,
    represent: $41a6607af35fbe66$var$representYamlBinary
});
var $41a6607af35fbe66$var$_hasOwnProperty$3 = Object.prototype.hasOwnProperty;
var $41a6607af35fbe66$var$_toString$2 = Object.prototype.toString;
function $41a6607af35fbe66$var$resolveYamlOmap(data) {
    if (data === null) return true;
    var objectKeys = [], index, length, pair, pairKey, pairHasKey, object = data;
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        pairHasKey = false;
        if ($41a6607af35fbe66$var$_toString$2.call(pair) !== '[object Object]') return false;
        for(pairKey in pair)if ($41a6607af35fbe66$var$_hasOwnProperty$3.call(pair, pairKey)) {
            if (!pairHasKey) pairHasKey = true;
            else return false;
        }
        if (!pairHasKey) return false;
        if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);
        else return false;
    }
    return true;
}
function $41a6607af35fbe66$var$constructYamlOmap(data) {
    return data !== null ? data : [];
}
var $41a6607af35fbe66$var$omap = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:omap', {
    kind: 'sequence',
    resolve: $41a6607af35fbe66$var$resolveYamlOmap,
    construct: $41a6607af35fbe66$var$constructYamlOmap
});
var $41a6607af35fbe66$var$_toString$1 = Object.prototype.toString;
function $41a6607af35fbe66$var$resolveYamlPairs(data) {
    if (data === null) return true;
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        if ($41a6607af35fbe66$var$_toString$1.call(pair) !== '[object Object]') return false;
        keys = Object.keys(pair);
        if (keys.length !== 1) return false;
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return true;
}
function $41a6607af35fbe66$var$constructYamlPairs(data) {
    if (data === null) return [];
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        keys = Object.keys(pair);
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return result;
}
var $41a6607af35fbe66$var$pairs = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:pairs', {
    kind: 'sequence',
    resolve: $41a6607af35fbe66$var$resolveYamlPairs,
    construct: $41a6607af35fbe66$var$constructYamlPairs
});
var $41a6607af35fbe66$var$_hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function $41a6607af35fbe66$var$resolveYamlSet(data) {
    if (data === null) return true;
    var key, object = data;
    for(key in object)if ($41a6607af35fbe66$var$_hasOwnProperty$2.call(object, key)) {
        if (object[key] !== null) return false;
    }
    return true;
}
function $41a6607af35fbe66$var$constructYamlSet(data) {
    return data !== null ? data : {};
}
var $41a6607af35fbe66$var$set = new $41a6607af35fbe66$var$type('tag:yaml.org,2002:set', {
    kind: 'mapping',
    resolve: $41a6607af35fbe66$var$resolveYamlSet,
    construct: $41a6607af35fbe66$var$constructYamlSet
});
var $41a6607af35fbe66$var$_default = $41a6607af35fbe66$var$core.extend({
    implicit: [
        $41a6607af35fbe66$var$timestamp,
        $41a6607af35fbe66$var$merge
    ],
    explicit: [
        $41a6607af35fbe66$var$binary,
        $41a6607af35fbe66$var$omap,
        $41a6607af35fbe66$var$pairs,
        $41a6607af35fbe66$var$set
    ]
});
/*eslint-disable max-len,no-use-before-define*/ var $41a6607af35fbe66$var$_hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var $41a6607af35fbe66$var$CONTEXT_FLOW_IN = 1;
var $41a6607af35fbe66$var$CONTEXT_FLOW_OUT = 2;
var $41a6607af35fbe66$var$CONTEXT_BLOCK_IN = 3;
var $41a6607af35fbe66$var$CONTEXT_BLOCK_OUT = 4;
var $41a6607af35fbe66$var$CHOMPING_CLIP = 1;
var $41a6607af35fbe66$var$CHOMPING_STRIP = 2;
var $41a6607af35fbe66$var$CHOMPING_KEEP = 3;
var $41a6607af35fbe66$var$PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
var $41a6607af35fbe66$var$PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
var $41a6607af35fbe66$var$PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/;
var $41a6607af35fbe66$var$PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i;
var $41a6607af35fbe66$var$PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
function $41a6607af35fbe66$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $41a6607af35fbe66$var$is_EOL(c) {
    return c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function $41a6607af35fbe66$var$is_WHITE_SPACE(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */ ;
}
function $41a6607af35fbe66$var$is_WS_OR_EOL(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */  || c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function $41a6607af35fbe66$var$is_FLOW_INDICATOR(c) {
    return c === 0x2C /* , */  || c === 0x5B /* [ */  || c === 0x5D /* ] */  || c === 0x7B /* { */  || c === 0x7D /* } */ ;
}
function $41a6607af35fbe66$var$fromHexCode(c) {
    var lc;
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    /*eslint-disable no-bitwise*/ lc = c | 0x20;
    if (0x61 /* a */  <= lc && lc <= 0x66 /* f */ ) return lc - 0x61 + 10;
    return -1;
}
function $41a6607af35fbe66$var$escapedHexLen(c) {
    if (c === 0x78 /* x */ ) return 2;
    if (c === 0x75 /* u */ ) return 4;
    if (c === 0x55 /* U */ ) return 8;
    return 0;
}
function $41a6607af35fbe66$var$fromDecimalCode(c) {
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    return -1;
}
function $41a6607af35fbe66$var$simpleEscapeSequence(c) {
    /* eslint-disable indent */ return c === 0x30 /* 0 */  ? '\x00' : c === 0x61 /* a */  ? '\x07' : c === 0x62 /* b */  ? '\x08' : c === 0x74 /* t */  ? '\x09' : c === 0x09 /* Tab */  ? '\x09' : c === 0x6E /* n */  ? '\x0A' : c === 0x76 /* v */  ? '\x0B' : c === 0x66 /* f */  ? '\x0C' : c === 0x72 /* r */  ? '\x0D' : c === 0x65 /* e */  ? '\x1B' : c === 0x20 /* Space */  ? ' ' : c === 0x22 /* " */  ? '\x22' : c === 0x2F /* / */  ? '/' : c === 0x5C /* \ */  ? '\x5C' : c === 0x4E /* N */  ? '\x85' : c === 0x5F /* _ */  ? '\xA0' : c === 0x4C /* L */  ? '\u2028' : c === 0x50 /* P */  ? '\u2029' : '';
}
function $41a6607af35fbe66$var$charFromCodepoint(c) {
    if (c <= 0xFFFF) return String.fromCharCode(c);
    // Encode UTF-16 surrogate pair
    // https://en.wikipedia.org/wiki/UTF-16#Code_points_U.2B010000_to_U.2B10FFFF
    return String.fromCharCode((c - 0x010000 >> 10) + 0xD800, (c - 0x010000 & 0x03FF) + 0xDC00);
}
var $41a6607af35fbe66$var$simpleEscapeCheck = new Array(256); // integer, for fast access
var $41a6607af35fbe66$var$simpleEscapeMap = new Array(256);
for(var $41a6607af35fbe66$var$i = 0; $41a6607af35fbe66$var$i < 256; $41a6607af35fbe66$var$i++){
    $41a6607af35fbe66$var$simpleEscapeCheck[$41a6607af35fbe66$var$i] = $41a6607af35fbe66$var$simpleEscapeSequence($41a6607af35fbe66$var$i) ? 1 : 0;
    $41a6607af35fbe66$var$simpleEscapeMap[$41a6607af35fbe66$var$i] = $41a6607af35fbe66$var$simpleEscapeSequence($41a6607af35fbe66$var$i);
}
function $41a6607af35fbe66$var$State$1(input, options) {
    this.input = input;
    this.filename = options['filename'] || null;
    this.schema = options['schema'] || $41a6607af35fbe66$var$_default;
    this.onWarning = options['onWarning'] || null;
    // (Hidden) Remove? makes the loader to expect YAML 1.1 documents
    // if such documents have no explicit %YAML directive
    this.legacy = options['legacy'] || false;
    this.json = options['json'] || false;
    this.listener = options['listener'] || null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.typeMap = this.schema.compiledTypeMap;
    this.length = input.length;
    this.position = 0;
    this.line = 0;
    this.lineStart = 0;
    this.lineIndent = 0;
    // position of first leading tab in the current line,
    // used to make sure there are no tabs in the indentation
    this.firstTabInLine = -1;
    this.documents = [];
/*
  this.version;
  this.checkLineBreaks;
  this.tagMap;
  this.anchorMap;
  this.tag;
  this.anchor;
  this.kind;
  this.result;*/ }
function $41a6607af35fbe66$var$generateError(state, message) {
    var mark = {
        name: state.filename,
        buffer: state.input.slice(0, -1),
        position: state.position,
        line: state.line,
        column: state.position - state.lineStart
    };
    mark.snippet = $41a6607af35fbe66$var$snippet(mark);
    return new $41a6607af35fbe66$var$exception(message, mark);
}
function $41a6607af35fbe66$var$throwError(state, message) {
    throw $41a6607af35fbe66$var$generateError(state, message);
}
function $41a6607af35fbe66$var$throwWarning(state, message) {
    if (state.onWarning) state.onWarning.call(null, $41a6607af35fbe66$var$generateError(state, message));
}
var $41a6607af35fbe66$var$directiveHandlers = {
    YAML: function handleYamlDirective(state, name, args) {
        var match, major, minor;
        if (state.version !== null) $41a6607af35fbe66$var$throwError(state, 'duplication of %YAML directive');
        if (args.length !== 1) $41a6607af35fbe66$var$throwError(state, 'YAML directive accepts exactly one argument');
        match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);
        if (match === null) $41a6607af35fbe66$var$throwError(state, 'ill-formed argument of the YAML directive');
        major = parseInt(match[1], 10);
        minor = parseInt(match[2], 10);
        if (major !== 1) $41a6607af35fbe66$var$throwError(state, 'unacceptable YAML version of the document');
        state.version = args[0];
        state.checkLineBreaks = minor < 2;
        if (minor !== 1 && minor !== 2) $41a6607af35fbe66$var$throwWarning(state, 'unsupported YAML version of the document');
    },
    TAG: function handleTagDirective(state, name, args) {
        var handle, prefix;
        if (args.length !== 2) $41a6607af35fbe66$var$throwError(state, 'TAG directive accepts exactly two arguments');
        handle = args[0];
        prefix = args[1];
        if (!$41a6607af35fbe66$var$PATTERN_TAG_HANDLE.test(handle)) $41a6607af35fbe66$var$throwError(state, 'ill-formed tag handle (first argument) of the TAG directive');
        if ($41a6607af35fbe66$var$_hasOwnProperty$1.call(state.tagMap, handle)) $41a6607af35fbe66$var$throwError(state, 'there is a previously declared suffix for "' + handle + '" tag handle');
        if (!$41a6607af35fbe66$var$PATTERN_TAG_URI.test(prefix)) $41a6607af35fbe66$var$throwError(state, 'ill-formed tag prefix (second argument) of the TAG directive');
        try {
            prefix = decodeURIComponent(prefix);
        } catch (err) {
            $41a6607af35fbe66$var$throwError(state, 'tag prefix is malformed: ' + prefix);
        }
        state.tagMap[handle] = prefix;
    }
};
function $41a6607af35fbe66$var$captureSegment(state, start, end, checkJson) {
    var _position, _length, _character, _result;
    if (start < end) {
        _result = state.input.slice(start, end);
        if (checkJson) for(_position = 0, _length = _result.length; _position < _length; _position += 1){
            _character = _result.charCodeAt(_position);
            if (!(_character === 0x09 || 0x20 <= _character && _character <= 0x10FFFF)) $41a6607af35fbe66$var$throwError(state, 'expected valid JSON character');
        }
        else if ($41a6607af35fbe66$var$PATTERN_NON_PRINTABLE.test(_result)) $41a6607af35fbe66$var$throwError(state, 'the stream contains non-printable characters');
        state.result += _result;
    }
}
function $41a6607af35fbe66$var$mergeMappings(state, destination, source, overridableKeys) {
    var sourceKeys, key, index, quantity;
    if (!$41a6607af35fbe66$var$common.isObject(source)) $41a6607af35fbe66$var$throwError(state, 'cannot merge mappings; the provided source object is unacceptable');
    sourceKeys = Object.keys(source);
    for(index = 0, quantity = sourceKeys.length; index < quantity; index += 1){
        key = sourceKeys[index];
        if (!$41a6607af35fbe66$var$_hasOwnProperty$1.call(destination, key)) {
            destination[key] = source[key];
            overridableKeys[key] = true;
        }
    }
}
function $41a6607af35fbe66$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, startLine, startLineStart, startPos) {
    var index, quantity;
    // The output is a plain object here, so keys can only be strings.
    // We need to convert keyNode to a string, but doing so can hang the process
    // (deeply nested arrays that explode exponentially using aliases).
    if (Array.isArray(keyNode)) {
        keyNode = Array.prototype.slice.call(keyNode);
        for(index = 0, quantity = keyNode.length; index < quantity; index += 1){
            if (Array.isArray(keyNode[index])) $41a6607af35fbe66$var$throwError(state, 'nested arrays are not supported inside keys');
            if ((typeof keyNode === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(keyNode)) === 'object' && $41a6607af35fbe66$var$_class(keyNode[index]) === '[object Object]') keyNode[index] = '[object Object]';
        }
    }
    // Avoid code execution in load() via toString property
    // (still use its own toString for arrays, timestamps,
    // and whatever user schema extensions happen to have @@toStringTag)
    if ((typeof keyNode === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(keyNode)) === 'object' && $41a6607af35fbe66$var$_class(keyNode) === '[object Object]') keyNode = '[object Object]';
    keyNode = String(keyNode);
    if (_result === null) _result = {};
    if (keyTag === 'tag:yaml.org,2002:merge') {
        if (Array.isArray(valueNode)) for(index = 0, quantity = valueNode.length; index < quantity; index += 1)$41a6607af35fbe66$var$mergeMappings(state, _result, valueNode[index], overridableKeys);
        else $41a6607af35fbe66$var$mergeMappings(state, _result, valueNode, overridableKeys);
    } else {
        if (!state.json && !$41a6607af35fbe66$var$_hasOwnProperty$1.call(overridableKeys, keyNode) && $41a6607af35fbe66$var$_hasOwnProperty$1.call(_result, keyNode)) {
            state.line = startLine || state.line;
            state.lineStart = startLineStart || state.lineStart;
            state.position = startPos || state.position;
            $41a6607af35fbe66$var$throwError(state, 'duplicated mapping key');
        }
        // used for this specific key only because Object.defineProperty is slow
        if (keyNode === '__proto__') Object.defineProperty(_result, keyNode, {
            configurable: true,
            enumerable: true,
            writable: true,
            value: valueNode
        });
        else _result[keyNode] = valueNode;
        delete overridableKeys[keyNode];
    }
    return _result;
}
function $41a6607af35fbe66$var$readLineBreak(state) {
    var ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x0A /* LF */ ) state.position++;
    else if (ch === 0x0D /* CR */ ) {
        state.position++;
        if (state.input.charCodeAt(state.position) === 0x0A /* LF */ ) state.position++;
    } else $41a6607af35fbe66$var$throwError(state, 'a line break is expected');
    state.line += 1;
    state.lineStart = state.position;
    state.firstTabInLine = -1;
}
function $41a6607af35fbe66$var$skipSeparationSpace(state, allowComments, checkIndent) {
    var lineBreaks = 0, ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        while($41a6607af35fbe66$var$is_WHITE_SPACE(ch)){
            if (ch === 0x09 /* Tab */  && state.firstTabInLine === -1) state.firstTabInLine = state.position;
            ch = state.input.charCodeAt(++state.position);
        }
        if (allowComments && ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0x0A /* LF */  && ch !== 0x0D /* CR */  && ch !== 0);
        if ($41a6607af35fbe66$var$is_EOL(ch)) {
            $41a6607af35fbe66$var$readLineBreak(state);
            ch = state.input.charCodeAt(state.position);
            lineBreaks++;
            state.lineIndent = 0;
            while(ch === 0x20 /* Space */ ){
                state.lineIndent++;
                ch = state.input.charCodeAt(++state.position);
            }
        } else break;
    }
    if (checkIndent !== -1 && lineBreaks !== 0 && state.lineIndent < checkIndent) $41a6607af35fbe66$var$throwWarning(state, 'deficient indentation');
    return lineBreaks;
}
function $41a6607af35fbe66$var$testDocumentSeparator(state) {
    var _position = state.position, ch;
    ch = state.input.charCodeAt(_position);
    // Condition state.position === state.lineStart is tested
    // in parent on each call, for efficiency. No needs to test here again.
    if ((ch === 0x2D /* - */  || ch === 0x2E /* . */ ) && ch === state.input.charCodeAt(_position + 1) && ch === state.input.charCodeAt(_position + 2)) {
        _position += 3;
        ch = state.input.charCodeAt(_position);
        if (ch === 0 || $41a6607af35fbe66$var$is_WS_OR_EOL(ch)) return true;
    }
    return false;
}
function $41a6607af35fbe66$var$writeFoldedLines(state, count) {
    if (count === 1) state.result += ' ';
    else if (count > 1) state.result += $41a6607af35fbe66$var$common.repeat('\n', count - 1);
}
function $41a6607af35fbe66$var$readPlainScalar(state, nodeIndent, withinFlowCollection) {
    var preceding, following, captureStart, captureEnd, hasPendingContent, _line, _lineStart, _lineIndent, _kind = state.kind, _result = state.result, ch;
    ch = state.input.charCodeAt(state.position);
    if ($41a6607af35fbe66$var$is_WS_OR_EOL(ch) || $41a6607af35fbe66$var$is_FLOW_INDICATOR(ch) || ch === 0x23 /* # */  || ch === 0x26 /* & */  || ch === 0x2A /* * */  || ch === 0x21 /* ! */  || ch === 0x7C /* | */  || ch === 0x3E /* > */  || ch === 0x27 /* ' */  || ch === 0x22 /* " */  || ch === 0x25 /* % */  || ch === 0x40 /* @ */  || ch === 0x60 /* ` */ ) return false;
    if (ch === 0x3F /* ? */  || ch === 0x2D /* - */ ) {
        following = state.input.charCodeAt(state.position + 1);
        if ($41a6607af35fbe66$var$is_WS_OR_EOL(following) || withinFlowCollection && $41a6607af35fbe66$var$is_FLOW_INDICATOR(following)) return false;
    }
    state.kind = 'scalar';
    state.result = '';
    captureStart = captureEnd = state.position;
    hasPendingContent = false;
    while(ch !== 0){
        if (ch === 0x3A /* : */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if ($41a6607af35fbe66$var$is_WS_OR_EOL(following) || withinFlowCollection && $41a6607af35fbe66$var$is_FLOW_INDICATOR(following)) break;
        } else if (ch === 0x23 /* # */ ) {
            preceding = state.input.charCodeAt(state.position - 1);
            if ($41a6607af35fbe66$var$is_WS_OR_EOL(preceding)) break;
        } else if (state.position === state.lineStart && $41a6607af35fbe66$var$testDocumentSeparator(state) || withinFlowCollection && $41a6607af35fbe66$var$is_FLOW_INDICATOR(ch)) break;
        else if ($41a6607af35fbe66$var$is_EOL(ch)) {
            _line = state.line;
            _lineStart = state.lineStart;
            _lineIndent = state.lineIndent;
            $41a6607af35fbe66$var$skipSeparationSpace(state, false, -1);
            if (state.lineIndent >= nodeIndent) {
                hasPendingContent = true;
                ch = state.input.charCodeAt(state.position);
                continue;
            } else {
                state.position = captureEnd;
                state.line = _line;
                state.lineStart = _lineStart;
                state.lineIndent = _lineIndent;
                break;
            }
        }
        if (hasPendingContent) {
            $41a6607af35fbe66$var$captureSegment(state, captureStart, captureEnd, false);
            $41a6607af35fbe66$var$writeFoldedLines(state, state.line - _line);
            captureStart = captureEnd = state.position;
            hasPendingContent = false;
        }
        if (!$41a6607af35fbe66$var$is_WHITE_SPACE(ch)) captureEnd = state.position + 1;
        ch = state.input.charCodeAt(++state.position);
    }
    $41a6607af35fbe66$var$captureSegment(state, captureStart, captureEnd, false);
    if (state.result) return true;
    state.kind = _kind;
    state.result = _result;
    return false;
}
function $41a6607af35fbe66$var$readSingleQuotedScalar(state, nodeIndent) {
    var ch, captureStart, captureEnd;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x27 /* ' */ ) return false;
    state.kind = 'scalar';
    state.result = '';
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x27 /* ' */ ) {
            $41a6607af35fbe66$var$captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if (ch === 0x27 /* ' */ ) {
                captureStart = state.position;
                state.position++;
                captureEnd = state.position;
            } else return true;
        } else if ($41a6607af35fbe66$var$is_EOL(ch)) {
            $41a6607af35fbe66$var$captureSegment(state, captureStart, captureEnd, true);
            $41a6607af35fbe66$var$writeFoldedLines(state, $41a6607af35fbe66$var$skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && $41a6607af35fbe66$var$testDocumentSeparator(state)) $41a6607af35fbe66$var$throwError(state, 'unexpected end of the document within a single quoted scalar');
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    $41a6607af35fbe66$var$throwError(state, 'unexpected end of the stream within a single quoted scalar');
}
function $41a6607af35fbe66$var$readDoubleQuotedScalar(state, nodeIndent) {
    var captureStart, captureEnd, hexLength, hexResult, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x22 /* " */ ) return false;
    state.kind = 'scalar';
    state.result = '';
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x22 /* " */ ) {
            $41a6607af35fbe66$var$captureSegment(state, captureStart, state.position, true);
            state.position++;
            return true;
        } else if (ch === 0x5C /* \ */ ) {
            $41a6607af35fbe66$var$captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if ($41a6607af35fbe66$var$is_EOL(ch)) $41a6607af35fbe66$var$skipSeparationSpace(state, false, nodeIndent);
            else if (ch < 256 && $41a6607af35fbe66$var$simpleEscapeCheck[ch]) {
                state.result += $41a6607af35fbe66$var$simpleEscapeMap[ch];
                state.position++;
            } else if ((tmp = $41a6607af35fbe66$var$escapedHexLen(ch)) > 0) {
                hexLength = tmp;
                hexResult = 0;
                for(; hexLength > 0; hexLength--){
                    ch = state.input.charCodeAt(++state.position);
                    if ((tmp = $41a6607af35fbe66$var$fromHexCode(ch)) >= 0) hexResult = (hexResult << 4) + tmp;
                    else $41a6607af35fbe66$var$throwError(state, 'expected hexadecimal character');
                }
                state.result += $41a6607af35fbe66$var$charFromCodepoint(hexResult);
                state.position++;
            } else $41a6607af35fbe66$var$throwError(state, 'unknown escape sequence');
            captureStart = captureEnd = state.position;
        } else if ($41a6607af35fbe66$var$is_EOL(ch)) {
            $41a6607af35fbe66$var$captureSegment(state, captureStart, captureEnd, true);
            $41a6607af35fbe66$var$writeFoldedLines(state, $41a6607af35fbe66$var$skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && $41a6607af35fbe66$var$testDocumentSeparator(state)) $41a6607af35fbe66$var$throwError(state, 'unexpected end of the document within a double quoted scalar');
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    $41a6607af35fbe66$var$throwError(state, 'unexpected end of the stream within a double quoted scalar');
}
function $41a6607af35fbe66$var$readFlowCollection(state, nodeIndent) {
    var readNext = true, _line, _lineStart, _pos, _tag = state.tag, _result, _anchor = state.anchor, following, terminator, isPair, isExplicitPair, isMapping, overridableKeys = Object.create(null), keyNode, keyTag, valueNode, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x5B /* [ */ ) {
        terminator = 0x5D; /* ] */ 
        isMapping = false;
        _result = [];
    } else if (ch === 0x7B /* { */ ) {
        terminator = 0x7D; /* } */ 
        isMapping = true;
        _result = {};
    } else return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(++state.position);
    while(ch !== 0){
        $41a6607af35fbe66$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === terminator) {
            state.position++;
            state.tag = _tag;
            state.anchor = _anchor;
            state.kind = isMapping ? 'mapping' : 'sequence';
            state.result = _result;
            return true;
        } else if (!readNext) $41a6607af35fbe66$var$throwError(state, 'missed comma between flow collection entries');
        else if (ch === 0x2C /* , */ ) // "flow collection entries can never be completely empty", as per YAML 1.2, section 7.4
        $41a6607af35fbe66$var$throwError(state, "expected the node content, but found ','");
        keyTag = keyNode = valueNode = null;
        isPair = isExplicitPair = false;
        if (ch === 0x3F /* ? */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if ($41a6607af35fbe66$var$is_WS_OR_EOL(following)) {
                isPair = isExplicitPair = true;
                state.position++;
                $41a6607af35fbe66$var$skipSeparationSpace(state, true, nodeIndent);
            }
        }
        _line = state.line; // Save the current line.
        _lineStart = state.lineStart;
        _pos = state.position;
        $41a6607af35fbe66$var$composeNode(state, nodeIndent, $41a6607af35fbe66$var$CONTEXT_FLOW_IN, false, true);
        keyTag = state.tag;
        keyNode = state.result;
        $41a6607af35fbe66$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if ((isExplicitPair || state.line === _line) && ch === 0x3A /* : */ ) {
            isPair = true;
            ch = state.input.charCodeAt(++state.position);
            $41a6607af35fbe66$var$skipSeparationSpace(state, true, nodeIndent);
            $41a6607af35fbe66$var$composeNode(state, nodeIndent, $41a6607af35fbe66$var$CONTEXT_FLOW_IN, false, true);
            valueNode = state.result;
        }
        if (isMapping) $41a6607af35fbe66$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos);
        else if (isPair) _result.push($41a6607af35fbe66$var$storeMappingPair(state, null, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos));
        else _result.push(keyNode);
        $41a6607af35fbe66$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === 0x2C /* , */ ) {
            readNext = true;
            ch = state.input.charCodeAt(++state.position);
        } else readNext = false;
    }
    $41a6607af35fbe66$var$throwError(state, 'unexpected end of the stream within a flow collection');
}
function $41a6607af35fbe66$var$readBlockScalar(state, nodeIndent) {
    var captureStart, folding, chomping = $41a6607af35fbe66$var$CHOMPING_CLIP, didReadContent = false, detectedIndent = false, textIndent = nodeIndent, emptyLines = 0, atMoreIndented = false, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x7C /* | */ ) folding = false;
    else if (ch === 0x3E /* > */ ) folding = true;
    else return false;
    state.kind = 'scalar';
    state.result = '';
    while(ch !== 0){
        ch = state.input.charCodeAt(++state.position);
        if (ch === 0x2B /* + */  || ch === 0x2D /* - */ ) {
            if ($41a6607af35fbe66$var$CHOMPING_CLIP === chomping) chomping = ch === 0x2B /* + */  ? $41a6607af35fbe66$var$CHOMPING_KEEP : $41a6607af35fbe66$var$CHOMPING_STRIP;
            else $41a6607af35fbe66$var$throwError(state, 'repeat of a chomping mode identifier');
        } else if ((tmp = $41a6607af35fbe66$var$fromDecimalCode(ch)) >= 0) {
            if (tmp === 0) $41a6607af35fbe66$var$throwError(state, 'bad explicit indentation width of a block scalar; it cannot be less than one');
            else if (!detectedIndent) {
                textIndent = nodeIndent + tmp - 1;
                detectedIndent = true;
            } else $41a6607af35fbe66$var$throwError(state, 'repeat of an indentation width identifier');
        } else break;
    }
    if ($41a6607af35fbe66$var$is_WHITE_SPACE(ch)) {
        do ch = state.input.charCodeAt(++state.position);
        while ($41a6607af35fbe66$var$is_WHITE_SPACE(ch));
        if (ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (!$41a6607af35fbe66$var$is_EOL(ch) && ch !== 0);
    }
    while(ch !== 0){
        $41a6607af35fbe66$var$readLineBreak(state);
        state.lineIndent = 0;
        ch = state.input.charCodeAt(state.position);
        while((!detectedIndent || state.lineIndent < textIndent) && ch === 0x20 /* Space */ ){
            state.lineIndent++;
            ch = state.input.charCodeAt(++state.position);
        }
        if (!detectedIndent && state.lineIndent > textIndent) textIndent = state.lineIndent;
        if ($41a6607af35fbe66$var$is_EOL(ch)) {
            emptyLines++;
            continue;
        }
        // End of the scalar.
        if (state.lineIndent < textIndent) {
            // Perform the chomping.
            if (chomping === $41a6607af35fbe66$var$CHOMPING_KEEP) state.result += $41a6607af35fbe66$var$common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
            else if (chomping === $41a6607af35fbe66$var$CHOMPING_CLIP) {
                if (didReadContent) state.result += '\n';
            }
            break;
        }
        // Folded style: use fancy rules to handle line breaks.
        if (folding) {
            // Lines starting with white space characters (more-indented lines) are not folded.
            if ($41a6607af35fbe66$var$is_WHITE_SPACE(ch)) {
                atMoreIndented = true;
                // except for the first content line (cf. Example 8.1)
                state.result += $41a6607af35fbe66$var$common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
            // End of more-indented block.
            } else if (atMoreIndented) {
                atMoreIndented = false;
                state.result += $41a6607af35fbe66$var$common.repeat('\n', emptyLines + 1);
            // Just one line break - perceive as the same line.
            } else if (emptyLines === 0) {
                if (didReadContent) state.result += ' ';
            } else state.result += $41a6607af35fbe66$var$common.repeat('\n', emptyLines);
        // Literal style: just add exact number of line breaks between content lines.
        } else // Keep all line breaks except the header line break.
        state.result += $41a6607af35fbe66$var$common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
        didReadContent = true;
        detectedIndent = true;
        emptyLines = 0;
        captureStart = state.position;
        while(!$41a6607af35fbe66$var$is_EOL(ch) && ch !== 0)ch = state.input.charCodeAt(++state.position);
        $41a6607af35fbe66$var$captureSegment(state, captureStart, state.position, false);
    }
    return true;
}
function $41a6607af35fbe66$var$readBlockSequence(state, nodeIndent) {
    var _line, _tag = state.tag, _anchor = state.anchor, _result = [], following, detected = false, ch;
    // there is a leading tab before this token, so it can't be a block sequence/mapping;
    // it can still be flow sequence/mapping or a scalar
    if (state.firstTabInLine !== -1) return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        if (state.firstTabInLine !== -1) {
            state.position = state.firstTabInLine;
            $41a6607af35fbe66$var$throwError(state, 'tab characters must not be used in indentation');
        }
        if (ch !== 0x2D /* - */ ) break;
        following = state.input.charCodeAt(state.position + 1);
        if (!$41a6607af35fbe66$var$is_WS_OR_EOL(following)) break;
        detected = true;
        state.position++;
        if ($41a6607af35fbe66$var$skipSeparationSpace(state, true, -1)) {
            if (state.lineIndent <= nodeIndent) {
                _result.push(null);
                ch = state.input.charCodeAt(state.position);
                continue;
            }
        }
        _line = state.line;
        $41a6607af35fbe66$var$composeNode(state, nodeIndent, $41a6607af35fbe66$var$CONTEXT_BLOCK_IN, false, true);
        _result.push(state.result);
        $41a6607af35fbe66$var$skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) $41a6607af35fbe66$var$throwError(state, 'bad indentation of a sequence entry');
        else if (state.lineIndent < nodeIndent) break;
    }
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = 'sequence';
        state.result = _result;
        return true;
    }
    return false;
}
function $41a6607af35fbe66$var$readBlockMapping(state, nodeIndent, flowIndent) {
    var following, allowCompact, _line, _keyLine, _keyLineStart, _keyPos, _tag = state.tag, _anchor = state.anchor, _result = {}, overridableKeys = Object.create(null), keyTag = null, keyNode = null, valueNode = null, atExplicitKey = false, detected = false, ch;
    // there is a leading tab before this token, so it can't be a block sequence/mapping;
    // it can still be flow sequence/mapping or a scalar
    if (state.firstTabInLine !== -1) return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        if (!atExplicitKey && state.firstTabInLine !== -1) {
            state.position = state.firstTabInLine;
            $41a6607af35fbe66$var$throwError(state, 'tab characters must not be used in indentation');
        }
        following = state.input.charCodeAt(state.position + 1);
        _line = state.line; // Save the current line.
        //
        // Explicit notation case. There are two separate blocks:
        // first for the key (denoted by "?") and second for the value (denoted by ":")
        //
        if ((ch === 0x3F /* ? */  || ch === 0x3A /* : */ ) && $41a6607af35fbe66$var$is_WS_OR_EOL(following)) {
            if (ch === 0x3F /* ? */ ) {
                if (atExplicitKey) {
                    $41a6607af35fbe66$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                    keyTag = keyNode = valueNode = null;
                }
                detected = true;
                atExplicitKey = true;
                allowCompact = true;
            } else if (atExplicitKey) {
                // i.e. 0x3A/* : */ === character after the explicit key.
                atExplicitKey = false;
                allowCompact = true;
            } else $41a6607af35fbe66$var$throwError(state, 'incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line');
            state.position += 1;
            ch = following;
        //
        // Implicit notation case. Flow-style node as the key first, then ":", and the value.
        //
        } else {
            _keyLine = state.line;
            _keyLineStart = state.lineStart;
            _keyPos = state.position;
            if (!$41a6607af35fbe66$var$composeNode(state, flowIndent, $41a6607af35fbe66$var$CONTEXT_FLOW_OUT, false, true)) break;
            if (state.line === _line) {
                ch = state.input.charCodeAt(state.position);
                while($41a6607af35fbe66$var$is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
                if (ch === 0x3A /* : */ ) {
                    ch = state.input.charCodeAt(++state.position);
                    if (!$41a6607af35fbe66$var$is_WS_OR_EOL(ch)) $41a6607af35fbe66$var$throwError(state, 'a whitespace character is expected after the key-value separator within a block mapping');
                    if (atExplicitKey) {
                        $41a6607af35fbe66$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                        keyTag = keyNode = valueNode = null;
                    }
                    detected = true;
                    atExplicitKey = false;
                    allowCompact = false;
                    keyTag = state.tag;
                    keyNode = state.result;
                } else if (detected) $41a6607af35fbe66$var$throwError(state, 'can not read an implicit mapping pair; a colon is missed');
                else {
                    state.tag = _tag;
                    state.anchor = _anchor;
                    return true; // Keep the result of `composeNode`.
                }
            } else if (detected) $41a6607af35fbe66$var$throwError(state, 'can not read a block mapping entry; a multiline key may not be an implicit key');
            else {
                state.tag = _tag;
                state.anchor = _anchor;
                return true; // Keep the result of `composeNode`.
            }
        }
        //
        // Common reading code for both explicit and implicit notations.
        //
        if (state.line === _line || state.lineIndent > nodeIndent) {
            if (atExplicitKey) {
                _keyLine = state.line;
                _keyLineStart = state.lineStart;
                _keyPos = state.position;
            }
            if ($41a6607af35fbe66$var$composeNode(state, nodeIndent, $41a6607af35fbe66$var$CONTEXT_BLOCK_OUT, true, allowCompact)) {
                if (atExplicitKey) keyNode = state.result;
                else valueNode = state.result;
            }
            if (!atExplicitKey) {
                $41a6607af35fbe66$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _keyLine, _keyLineStart, _keyPos);
                keyTag = keyNode = valueNode = null;
            }
            $41a6607af35fbe66$var$skipSeparationSpace(state, true, -1);
            ch = state.input.charCodeAt(state.position);
        }
        if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) $41a6607af35fbe66$var$throwError(state, 'bad indentation of a mapping entry');
        else if (state.lineIndent < nodeIndent) break;
    }
    //
    // Epilogue.
    //
    // Special case: last mapping's node contains only the key in explicit notation.
    if (atExplicitKey) $41a6607af35fbe66$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
    // Expose the resulting mapping.
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = 'mapping';
        state.result = _result;
    }
    return detected;
}
function $41a6607af35fbe66$var$readTagProperty(state) {
    var _position, isVerbatim = false, isNamed = false, tagHandle, tagName, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x21 /* ! */ ) return false;
    if (state.tag !== null) $41a6607af35fbe66$var$throwError(state, 'duplication of a tag property');
    ch = state.input.charCodeAt(++state.position);
    if (ch === 0x3C /* < */ ) {
        isVerbatim = true;
        ch = state.input.charCodeAt(++state.position);
    } else if (ch === 0x21 /* ! */ ) {
        isNamed = true;
        tagHandle = '!!';
        ch = state.input.charCodeAt(++state.position);
    } else tagHandle = '!';
    _position = state.position;
    if (isVerbatim) {
        do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0 && ch !== 0x3E /* > */ );
        if (state.position < state.length) {
            tagName = state.input.slice(_position, state.position);
            ch = state.input.charCodeAt(++state.position);
        } else $41a6607af35fbe66$var$throwError(state, 'unexpected end of the stream within a verbatim tag');
    } else {
        while(ch !== 0 && !$41a6607af35fbe66$var$is_WS_OR_EOL(ch)){
            if (ch === 0x21 /* ! */ ) {
                if (!isNamed) {
                    tagHandle = state.input.slice(_position - 1, state.position + 1);
                    if (!$41a6607af35fbe66$var$PATTERN_TAG_HANDLE.test(tagHandle)) $41a6607af35fbe66$var$throwError(state, 'named tag handle cannot contain such characters');
                    isNamed = true;
                    _position = state.position + 1;
                } else $41a6607af35fbe66$var$throwError(state, 'tag suffix cannot contain exclamation marks');
            }
            ch = state.input.charCodeAt(++state.position);
        }
        tagName = state.input.slice(_position, state.position);
        if ($41a6607af35fbe66$var$PATTERN_FLOW_INDICATORS.test(tagName)) $41a6607af35fbe66$var$throwError(state, 'tag suffix cannot contain flow indicator characters');
    }
    if (tagName && !$41a6607af35fbe66$var$PATTERN_TAG_URI.test(tagName)) $41a6607af35fbe66$var$throwError(state, 'tag name cannot contain such characters: ' + tagName);
    try {
        tagName = decodeURIComponent(tagName);
    } catch (err) {
        $41a6607af35fbe66$var$throwError(state, 'tag name is malformed: ' + tagName);
    }
    if (isVerbatim) state.tag = tagName;
    else if ($41a6607af35fbe66$var$_hasOwnProperty$1.call(state.tagMap, tagHandle)) state.tag = state.tagMap[tagHandle] + tagName;
    else if (tagHandle === '!') state.tag = '!' + tagName;
    else if (tagHandle === '!!') state.tag = 'tag:yaml.org,2002:' + tagName;
    else $41a6607af35fbe66$var$throwError(state, 'undeclared tag handle "' + tagHandle + '"');
    return true;
}
function $41a6607af35fbe66$var$readAnchorProperty(state) {
    var _position, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x26 /* & */ ) return false;
    if (state.anchor !== null) $41a6607af35fbe66$var$throwError(state, 'duplication of an anchor property');
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !$41a6607af35fbe66$var$is_WS_OR_EOL(ch) && !$41a6607af35fbe66$var$is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) $41a6607af35fbe66$var$throwError(state, 'name of an anchor node must contain at least one character');
    state.anchor = state.input.slice(_position, state.position);
    return true;
}
function $41a6607af35fbe66$var$readAlias(state) {
    var _position, alias, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x2A /* * */ ) return false;
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !$41a6607af35fbe66$var$is_WS_OR_EOL(ch) && !$41a6607af35fbe66$var$is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) $41a6607af35fbe66$var$throwError(state, 'name of an alias node must contain at least one character');
    alias = state.input.slice(_position, state.position);
    if (!$41a6607af35fbe66$var$_hasOwnProperty$1.call(state.anchorMap, alias)) $41a6607af35fbe66$var$throwError(state, 'unidentified alias "' + alias + '"');
    state.result = state.anchorMap[alias];
    $41a6607af35fbe66$var$skipSeparationSpace(state, true, -1);
    return true;
}
function $41a6607af35fbe66$var$composeNode(state, parentIndent, nodeContext, allowToSeek, allowCompact) {
    var allowBlockStyles, allowBlockScalars, allowBlockCollections, indentStatus = 1, atNewLine = false, hasContent = false, typeIndex, typeQuantity, typeList, type, flowIndent, blockIndent;
    if (state.listener !== null) state.listener('open', state);
    state.tag = null;
    state.anchor = null;
    state.kind = null;
    state.result = null;
    allowBlockStyles = allowBlockScalars = allowBlockCollections = $41a6607af35fbe66$var$CONTEXT_BLOCK_OUT === nodeContext || $41a6607af35fbe66$var$CONTEXT_BLOCK_IN === nodeContext;
    if (allowToSeek) {
        if ($41a6607af35fbe66$var$skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        }
    }
    if (indentStatus === 1) {
        while($41a6607af35fbe66$var$readTagProperty(state) || $41a6607af35fbe66$var$readAnchorProperty(state))if ($41a6607af35fbe66$var$skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            allowBlockCollections = allowBlockStyles;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        } else allowBlockCollections = false;
    }
    if (allowBlockCollections) allowBlockCollections = atNewLine || allowCompact;
    if (indentStatus === 1 || $41a6607af35fbe66$var$CONTEXT_BLOCK_OUT === nodeContext) {
        if ($41a6607af35fbe66$var$CONTEXT_FLOW_IN === nodeContext || $41a6607af35fbe66$var$CONTEXT_FLOW_OUT === nodeContext) flowIndent = parentIndent;
        else flowIndent = parentIndent + 1;
        blockIndent = state.position - state.lineStart;
        if (indentStatus === 1) {
            if (allowBlockCollections && ($41a6607af35fbe66$var$readBlockSequence(state, blockIndent) || $41a6607af35fbe66$var$readBlockMapping(state, blockIndent, flowIndent)) || $41a6607af35fbe66$var$readFlowCollection(state, flowIndent)) hasContent = true;
            else {
                if (allowBlockScalars && $41a6607af35fbe66$var$readBlockScalar(state, flowIndent) || $41a6607af35fbe66$var$readSingleQuotedScalar(state, flowIndent) || $41a6607af35fbe66$var$readDoubleQuotedScalar(state, flowIndent)) hasContent = true;
                else if ($41a6607af35fbe66$var$readAlias(state)) {
                    hasContent = true;
                    if (state.tag !== null || state.anchor !== null) $41a6607af35fbe66$var$throwError(state, 'alias node should not have any properties');
                } else if ($41a6607af35fbe66$var$readPlainScalar(state, flowIndent, $41a6607af35fbe66$var$CONTEXT_FLOW_IN === nodeContext)) {
                    hasContent = true;
                    if (state.tag === null) state.tag = '?';
                }
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
            }
        } else if (indentStatus === 0) // Special case: block sequences are allowed to have same indentation level as the parent.
        // http://www.yaml.org/spec/1.2/spec.html#id2799784
        hasContent = allowBlockCollections && $41a6607af35fbe66$var$readBlockSequence(state, blockIndent);
    }
    if (state.tag === null) {
        if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
    } else if (state.tag === '?') {
        // Implicit resolving is not allowed for non-scalar types, and '?'
        // non-specific tag is only automatically assigned to plain scalars.
        //
        // We only need to check kind conformity in case user explicitly assigns '?'
        // tag, for example like this: "!<?> [0]"
        //
        if (state.result !== null && state.kind !== 'scalar') $41a6607af35fbe66$var$throwError(state, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state.kind + '"');
        for(typeIndex = 0, typeQuantity = state.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1){
            type = state.implicitTypes[typeIndex];
            if (type.resolve(state.result)) {
                state.result = type.construct(state.result);
                state.tag = type.tag;
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
                break;
            }
        }
    } else if (state.tag !== '!') {
        if ($41a6607af35fbe66$var$_hasOwnProperty$1.call(state.typeMap[state.kind || 'fallback'], state.tag)) type = state.typeMap[state.kind || 'fallback'][state.tag];
        else {
            // looking for multi type
            type = null;
            typeList = state.typeMap.multi[state.kind || 'fallback'];
            for(typeIndex = 0, typeQuantity = typeList.length; typeIndex < typeQuantity; typeIndex += 1)if (state.tag.slice(0, typeList[typeIndex].tag.length) === typeList[typeIndex].tag) {
                type = typeList[typeIndex];
                break;
            }
        }
        if (!type) $41a6607af35fbe66$var$throwError(state, 'unknown tag !<' + state.tag + '>');
        if (state.result !== null && type.kind !== state.kind) $41a6607af35fbe66$var$throwError(state, 'unacceptable node kind for !<' + state.tag + '> tag; it should be "' + type.kind + '", not "' + state.kind + '"');
        if (!type.resolve(state.result, state.tag)) $41a6607af35fbe66$var$throwError(state, 'cannot resolve a node with !<' + state.tag + '> explicit tag');
        else {
            state.result = type.construct(state.result, state.tag);
            if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
        }
    }
    if (state.listener !== null) state.listener('close', state);
    return state.tag !== null || state.anchor !== null || hasContent;
}
function $41a6607af35fbe66$var$readDocument(state) {
    var documentStart = state.position, _position, directiveName, directiveArgs, hasDirectives = false, ch;
    state.version = null;
    state.checkLineBreaks = state.legacy;
    state.tagMap = Object.create(null);
    state.anchorMap = Object.create(null);
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        $41a6607af35fbe66$var$skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if (state.lineIndent > 0 || ch !== 0x25 /* % */ ) break;
        hasDirectives = true;
        ch = state.input.charCodeAt(++state.position);
        _position = state.position;
        while(ch !== 0 && !$41a6607af35fbe66$var$is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
        directiveName = state.input.slice(_position, state.position);
        directiveArgs = [];
        if (directiveName.length < 1) $41a6607af35fbe66$var$throwError(state, 'directive name must not be less than one character in length');
        while(ch !== 0){
            while($41a6607af35fbe66$var$is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
            if (ch === 0x23 /* # */ ) {
                do ch = state.input.charCodeAt(++state.position);
                while (ch !== 0 && !$41a6607af35fbe66$var$is_EOL(ch));
                break;
            }
            if ($41a6607af35fbe66$var$is_EOL(ch)) break;
            _position = state.position;
            while(ch !== 0 && !$41a6607af35fbe66$var$is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
            directiveArgs.push(state.input.slice(_position, state.position));
        }
        if (ch !== 0) $41a6607af35fbe66$var$readLineBreak(state);
        if ($41a6607af35fbe66$var$_hasOwnProperty$1.call($41a6607af35fbe66$var$directiveHandlers, directiveName)) $41a6607af35fbe66$var$directiveHandlers[directiveName](state, directiveName, directiveArgs);
        else $41a6607af35fbe66$var$throwWarning(state, 'unknown document directive "' + directiveName + '"');
    }
    $41a6607af35fbe66$var$skipSeparationSpace(state, true, -1);
    if (state.lineIndent === 0 && state.input.charCodeAt(state.position) === 0x2D /* - */  && state.input.charCodeAt(state.position + 1) === 0x2D /* - */  && state.input.charCodeAt(state.position + 2) === 0x2D /* - */ ) {
        state.position += 3;
        $41a6607af35fbe66$var$skipSeparationSpace(state, true, -1);
    } else if (hasDirectives) $41a6607af35fbe66$var$throwError(state, 'directives end mark is expected');
    $41a6607af35fbe66$var$composeNode(state, state.lineIndent - 1, $41a6607af35fbe66$var$CONTEXT_BLOCK_OUT, false, true);
    $41a6607af35fbe66$var$skipSeparationSpace(state, true, -1);
    if (state.checkLineBreaks && $41a6607af35fbe66$var$PATTERN_NON_ASCII_LINE_BREAKS.test(state.input.slice(documentStart, state.position))) $41a6607af35fbe66$var$throwWarning(state, 'non-ASCII line breaks are interpreted as content');
    state.documents.push(state.result);
    if (state.position === state.lineStart && $41a6607af35fbe66$var$testDocumentSeparator(state)) {
        if (state.input.charCodeAt(state.position) === 0x2E /* . */ ) {
            state.position += 3;
            $41a6607af35fbe66$var$skipSeparationSpace(state, true, -1);
        }
        return;
    }
    if (state.position < state.length - 1) $41a6607af35fbe66$var$throwError(state, 'end of the stream or a document separator is expected');
    else return;
}
function $41a6607af35fbe66$var$loadDocuments(input, options) {
    input = String(input);
    options = options || {};
    if (input.length !== 0) {
        // Add tailing `\n` if not exists
        if (input.charCodeAt(input.length - 1) !== 0x0A /* LF */  && input.charCodeAt(input.length - 1) !== 0x0D /* CR */ ) input += '\n';
        // Strip BOM
        if (input.charCodeAt(0) === 0xFEFF) input = input.slice(1);
    }
    var state = new $41a6607af35fbe66$var$State$1(input, options);
    var nullpos = input.indexOf('\0');
    if (nullpos !== -1) {
        state.position = nullpos;
        $41a6607af35fbe66$var$throwError(state, 'null byte is not allowed in input');
    }
    // Use 0 as string terminator. That significantly simplifies bounds check.
    state.input += '\0';
    while(state.input.charCodeAt(state.position) === 0x20 /* Space */ ){
        state.lineIndent += 1;
        state.position += 1;
    }
    while(state.position < state.length - 1)$41a6607af35fbe66$var$readDocument(state);
    return state.documents;
}
function $41a6607af35fbe66$var$loadAll$1(input, iterator, options) {
    if (iterator !== null && (typeof iterator === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(iterator)) === 'object' && typeof options === 'undefined') {
        options = iterator;
        iterator = null;
    }
    var documents = $41a6607af35fbe66$var$loadDocuments(input, options);
    if (typeof iterator !== 'function') return documents;
    for(var index = 0, length = documents.length; index < length; index += 1)iterator(documents[index]);
}
function $41a6607af35fbe66$var$load$1(input, options) {
    var documents = $41a6607af35fbe66$var$loadDocuments(input, options);
    if (documents.length === 0) /*eslint-disable no-undefined*/ return undefined;
    else if (documents.length === 1) return documents[0];
    throw new $41a6607af35fbe66$var$exception('expected a single document in the stream, but found more');
}
var $41a6607af35fbe66$var$loadAll_1 = $41a6607af35fbe66$var$loadAll$1;
var $41a6607af35fbe66$var$load_1 = $41a6607af35fbe66$var$load$1;
var $41a6607af35fbe66$var$loader = {
    loadAll: $41a6607af35fbe66$var$loadAll_1,
    load: $41a6607af35fbe66$var$load_1
};
/*eslint-disable no-use-before-define*/ var $41a6607af35fbe66$var$_toString = Object.prototype.toString;
var $41a6607af35fbe66$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
var $41a6607af35fbe66$var$CHAR_BOM = 0xFEFF;
var $41a6607af35fbe66$var$CHAR_TAB = 0x09; /* Tab */ 
var $41a6607af35fbe66$var$CHAR_LINE_FEED = 0x0A; /* LF */ 
var $41a6607af35fbe66$var$CHAR_CARRIAGE_RETURN = 0x0D; /* CR */ 
var $41a6607af35fbe66$var$CHAR_SPACE = 0x20; /* Space */ 
var $41a6607af35fbe66$var$CHAR_EXCLAMATION = 0x21; /* ! */ 
var $41a6607af35fbe66$var$CHAR_DOUBLE_QUOTE = 0x22; /* " */ 
var $41a6607af35fbe66$var$CHAR_SHARP = 0x23; /* # */ 
var $41a6607af35fbe66$var$CHAR_PERCENT = 0x25; /* % */ 
var $41a6607af35fbe66$var$CHAR_AMPERSAND = 0x26; /* & */ 
var $41a6607af35fbe66$var$CHAR_SINGLE_QUOTE = 0x27; /* ' */ 
var $41a6607af35fbe66$var$CHAR_ASTERISK = 0x2A; /* * */ 
var $41a6607af35fbe66$var$CHAR_COMMA = 0x2C; /* , */ 
var $41a6607af35fbe66$var$CHAR_MINUS = 0x2D; /* - */ 
var $41a6607af35fbe66$var$CHAR_COLON = 0x3A; /* : */ 
var $41a6607af35fbe66$var$CHAR_EQUALS = 0x3D; /* = */ 
var $41a6607af35fbe66$var$CHAR_GREATER_THAN = 0x3E; /* > */ 
var $41a6607af35fbe66$var$CHAR_QUESTION = 0x3F; /* ? */ 
var $41a6607af35fbe66$var$CHAR_COMMERCIAL_AT = 0x40; /* @ */ 
var $41a6607af35fbe66$var$CHAR_LEFT_SQUARE_BRACKET = 0x5B; /* [ */ 
var $41a6607af35fbe66$var$CHAR_RIGHT_SQUARE_BRACKET = 0x5D; /* ] */ 
var $41a6607af35fbe66$var$CHAR_GRAVE_ACCENT = 0x60; /* ` */ 
var $41a6607af35fbe66$var$CHAR_LEFT_CURLY_BRACKET = 0x7B; /* { */ 
var $41a6607af35fbe66$var$CHAR_VERTICAL_LINE = 0x7C; /* | */ 
var $41a6607af35fbe66$var$CHAR_RIGHT_CURLY_BRACKET = 0x7D; /* } */ 
var $41a6607af35fbe66$var$ESCAPE_SEQUENCES = {};
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x00] = '\\0';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x07] = '\\a';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x08] = '\\b';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x09] = '\\t';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x0A] = '\\n';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x0B] = '\\v';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x0C] = '\\f';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x0D] = '\\r';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x1B] = '\\e';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x22] = '\\"';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x5C] = '\\\\';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x85] = '\\N';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0xA0] = '\\_';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x2028] = '\\L';
$41a6607af35fbe66$var$ESCAPE_SEQUENCES[0x2029] = '\\P';
var $41a6607af35fbe66$var$DEPRECATED_BOOLEANS_SYNTAX = [
    'y',
    'Y',
    'yes',
    'Yes',
    'YES',
    'on',
    'On',
    'ON',
    'n',
    'N',
    'no',
    'No',
    'NO',
    'off',
    'Off',
    'OFF'
];
var $41a6607af35fbe66$var$DEPRECATED_BASE60_SYNTAX = /^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;
function $41a6607af35fbe66$var$compileStyleMap(schema, map) {
    var result, keys, index, length, tag, style, type;
    if (map === null) return {};
    result = {};
    keys = Object.keys(map);
    for(index = 0, length = keys.length; index < length; index += 1){
        tag = keys[index];
        style = String(map[tag]);
        if (tag.slice(0, 2) === '!!') tag = 'tag:yaml.org,2002:' + tag.slice(2);
        type = schema.compiledTypeMap['fallback'][tag];
        if (type && $41a6607af35fbe66$var$_hasOwnProperty.call(type.styleAliases, style)) style = type.styleAliases[style];
        result[tag] = style;
    }
    return result;
}
function $41a6607af35fbe66$var$encodeHex(character) {
    var string, handle, length;
    string = character.toString(16).toUpperCase();
    if (character <= 0xFF) {
        handle = 'x';
        length = 2;
    } else if (character <= 0xFFFF) {
        handle = 'u';
        length = 4;
    } else if (character <= 0xFFFFFFFF) {
        handle = 'U';
        length = 8;
    } else throw new $41a6607af35fbe66$var$exception('code point within a string may not be greater than 0xFFFFFFFF');
    return '\\' + handle + $41a6607af35fbe66$var$common.repeat('0', length - string.length) + string;
}
var $41a6607af35fbe66$var$QUOTING_TYPE_SINGLE = 1, $41a6607af35fbe66$var$QUOTING_TYPE_DOUBLE = 2;
function $41a6607af35fbe66$var$State(options) {
    this.schema = options['schema'] || $41a6607af35fbe66$var$_default;
    this.indent = Math.max(1, options['indent'] || 2);
    this.noArrayIndent = options['noArrayIndent'] || false;
    this.skipInvalid = options['skipInvalid'] || false;
    this.flowLevel = $41a6607af35fbe66$var$common.isNothing(options['flowLevel']) ? -1 : options['flowLevel'];
    this.styleMap = $41a6607af35fbe66$var$compileStyleMap(this.schema, options['styles'] || null);
    this.sortKeys = options['sortKeys'] || false;
    this.lineWidth = options['lineWidth'] || 80;
    this.noRefs = options['noRefs'] || false;
    this.noCompatMode = options['noCompatMode'] || false;
    this.condenseFlow = options['condenseFlow'] || false;
    this.quotingType = options['quotingType'] === '"' ? $41a6607af35fbe66$var$QUOTING_TYPE_DOUBLE : $41a6607af35fbe66$var$QUOTING_TYPE_SINGLE;
    this.forceQuotes = options['forceQuotes'] || false;
    this.replacer = typeof options['replacer'] === 'function' ? options['replacer'] : null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.explicitTypes = this.schema.compiledExplicit;
    this.tag = null;
    this.result = '';
    this.duplicates = [];
    this.usedDuplicates = null;
}
// Indents every line in a string. Empty lines (\n only) are not indented.
function $41a6607af35fbe66$var$indentString(string, spaces) {
    var ind = $41a6607af35fbe66$var$common.repeat(' ', spaces), position = 0, next = -1, result = '', line, length = string.length;
    while(position < length){
        next = string.indexOf('\n', position);
        if (next === -1) {
            line = string.slice(position);
            position = length;
        } else {
            line = string.slice(position, next + 1);
            position = next + 1;
        }
        if (line.length && line !== '\n') result += ind;
        result += line;
    }
    return result;
}
function $41a6607af35fbe66$var$generateNextLine(state, level) {
    return '\n' + $41a6607af35fbe66$var$common.repeat(' ', state.indent * level);
}
function $41a6607af35fbe66$var$testImplicitResolving(state, str) {
    var index, length, type;
    for(index = 0, length = state.implicitTypes.length; index < length; index += 1){
        type = state.implicitTypes[index];
        if (type.resolve(str)) return true;
    }
    return false;
}
// [33] s-white ::= s-space | s-tab
function $41a6607af35fbe66$var$isWhitespace(c) {
    return c === $41a6607af35fbe66$var$CHAR_SPACE || c === $41a6607af35fbe66$var$CHAR_TAB;
}
// Returns true if the character can be printed without escaping.
// From YAML 1.2: "any allowed characters known to be non-printable
// should also be escaped. [However,] This isn’t mandatory"
// Derived from nb-char - \t - #x85 - #xA0 - #x2028 - #x2029.
function $41a6607af35fbe66$var$isPrintable(c) {
    return 0x00020 <= c && c <= 0x00007E || 0x000A1 <= c && c <= 0x00D7FF && c !== 0x2028 && c !== 0x2029 || 0x0E000 <= c && c <= 0x00FFFD && c !== $41a6607af35fbe66$var$CHAR_BOM || 0x10000 <= c && c <= 0x10FFFF;
}
// [34] ns-char ::= nb-char - s-white
// [27] nb-char ::= c-printable - b-char - c-byte-order-mark
// [26] b-char  ::= b-line-feed | b-carriage-return
// Including s-white (for some reason, examples doesn't match specs in this aspect)
// ns-char ::= c-printable - b-line-feed - b-carriage-return - c-byte-order-mark
function $41a6607af35fbe66$var$isNsCharOrWhitespace(c) {
    return $41a6607af35fbe66$var$isPrintable(c) && c !== $41a6607af35fbe66$var$CHAR_BOM && c !== $41a6607af35fbe66$var$CHAR_CARRIAGE_RETURN && c !== $41a6607af35fbe66$var$CHAR_LINE_FEED;
}
// [127]  ns-plain-safe(c) ::= c = flow-out  ⇒ ns-plain-safe-out
//                             c = flow-in   ⇒ ns-plain-safe-in
//                             c = block-key ⇒ ns-plain-safe-out
//                             c = flow-key  ⇒ ns-plain-safe-in
// [128] ns-plain-safe-out ::= ns-char
// [129]  ns-plain-safe-in ::= ns-char - c-flow-indicator
// [130]  ns-plain-char(c) ::=  ( ns-plain-safe(c) - “:” - “#” )
//                            | ( /* An ns-char preceding */ “#” )
//                            | ( “:” /* Followed by an ns-plain-safe(c) */ )
function $41a6607af35fbe66$var$isPlainSafe(c, prev, inblock) {
    var cIsNsCharOrWhitespace = $41a6607af35fbe66$var$isNsCharOrWhitespace(c);
    var cIsNsChar = cIsNsCharOrWhitespace && !$41a6607af35fbe66$var$isWhitespace(c);
    return(// ns-plain-safe
    (inblock ? cIsNsCharOrWhitespace : cIsNsCharOrWhitespace && c !== $41a6607af35fbe66$var$CHAR_COMMA && c !== $41a6607af35fbe66$var$CHAR_LEFT_SQUARE_BRACKET && c !== $41a6607af35fbe66$var$CHAR_RIGHT_SQUARE_BRACKET && c !== $41a6607af35fbe66$var$CHAR_LEFT_CURLY_BRACKET && c !== $41a6607af35fbe66$var$CHAR_RIGHT_CURLY_BRACKET) && c !== $41a6607af35fbe66$var$CHAR_SHARP // false on '#'
     && !(prev === $41a6607af35fbe66$var$CHAR_COLON && !cIsNsChar // false on ': '
    ) || $41a6607af35fbe66$var$isNsCharOrWhitespace(prev) && !$41a6607af35fbe66$var$isWhitespace(prev) && c === $41a6607af35fbe66$var$CHAR_SHARP // change to true on '[^ ]#'
     || prev === $41a6607af35fbe66$var$CHAR_COLON && cIsNsChar); // change to true on ':[^ ]'
}
// Simplified test for values allowed as the first character in plain style.
function $41a6607af35fbe66$var$isPlainSafeFirst(c) {
    // Uses a subset of ns-char - c-indicator
    // where ns-char = nb-char - s-white.
    // No support of ( ( “?” | “:” | “-” ) /* Followed by an ns-plain-safe(c)) */ ) part
    return $41a6607af35fbe66$var$isPrintable(c) && c !== $41a6607af35fbe66$var$CHAR_BOM && !$41a6607af35fbe66$var$isWhitespace(c) // - s-white
     && c !== $41a6607af35fbe66$var$CHAR_MINUS && c !== $41a6607af35fbe66$var$CHAR_QUESTION && c !== $41a6607af35fbe66$var$CHAR_COLON && c !== $41a6607af35fbe66$var$CHAR_COMMA && c !== $41a6607af35fbe66$var$CHAR_LEFT_SQUARE_BRACKET && c !== $41a6607af35fbe66$var$CHAR_RIGHT_SQUARE_BRACKET && c !== $41a6607af35fbe66$var$CHAR_LEFT_CURLY_BRACKET && c !== $41a6607af35fbe66$var$CHAR_RIGHT_CURLY_BRACKET && c !== $41a6607af35fbe66$var$CHAR_SHARP && c !== $41a6607af35fbe66$var$CHAR_AMPERSAND && c !== $41a6607af35fbe66$var$CHAR_ASTERISK && c !== $41a6607af35fbe66$var$CHAR_EXCLAMATION && c !== $41a6607af35fbe66$var$CHAR_VERTICAL_LINE && c !== $41a6607af35fbe66$var$CHAR_EQUALS && c !== $41a6607af35fbe66$var$CHAR_GREATER_THAN && c !== $41a6607af35fbe66$var$CHAR_SINGLE_QUOTE && c !== $41a6607af35fbe66$var$CHAR_DOUBLE_QUOTE && c !== $41a6607af35fbe66$var$CHAR_PERCENT && c !== $41a6607af35fbe66$var$CHAR_COMMERCIAL_AT && c !== $41a6607af35fbe66$var$CHAR_GRAVE_ACCENT;
}
// Simplified test for values allowed as the last character in plain style.
function $41a6607af35fbe66$var$isPlainSafeLast(c) {
    // just not whitespace or colon, it will be checked to be plain character later
    return !$41a6607af35fbe66$var$isWhitespace(c) && c !== $41a6607af35fbe66$var$CHAR_COLON;
}
// Same as 'string'.codePointAt(pos), but works in older browsers.
function $41a6607af35fbe66$var$codePointAt(string, pos) {
    var first = string.charCodeAt(pos), second;
    if (first >= 0xD800 && first <= 0xDBFF && pos + 1 < string.length) {
        second = string.charCodeAt(pos + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
// Determines whether block indentation indicator is required.
function $41a6607af35fbe66$var$needIndentIndicator(string) {
    var leadingSpaceRe = /^\n* /;
    return leadingSpaceRe.test(string);
}
var $41a6607af35fbe66$var$STYLE_PLAIN = 1, $41a6607af35fbe66$var$STYLE_SINGLE = 2, $41a6607af35fbe66$var$STYLE_LITERAL = 3, $41a6607af35fbe66$var$STYLE_FOLDED = 4, $41a6607af35fbe66$var$STYLE_DOUBLE = 5;
// Determines which scalar styles are possible and returns the preferred style.
// lineWidth = -1 => no limit.
// Pre-conditions: str.length > 0.
// Post-conditions:
//    STYLE_PLAIN or STYLE_SINGLE => no \n are in the string.
//    STYLE_LITERAL => no lines are suitable for folding (or lineWidth is -1).
//    STYLE_FOLDED => a line > lineWidth and can be folded (and lineWidth != -1).
function $41a6607af35fbe66$var$chooseScalarStyle(string, singleLineOnly, indentPerLevel, lineWidth, testAmbiguousType, quotingType, forceQuotes, inblock) {
    var i;
    var char = 0;
    var prevChar = null;
    var hasLineBreak = false;
    var hasFoldableLine = false; // only checked if shouldTrackWidth
    var shouldTrackWidth = lineWidth !== -1;
    var previousLineBreak = -1; // count the first line correctly
    var plain = $41a6607af35fbe66$var$isPlainSafeFirst($41a6607af35fbe66$var$codePointAt(string, 0)) && $41a6607af35fbe66$var$isPlainSafeLast($41a6607af35fbe66$var$codePointAt(string, string.length - 1));
    if (singleLineOnly || forceQuotes) // Case: no block styles.
    // Check for disallowed characters to rule out plain and single.
    for(i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
        char = $41a6607af35fbe66$var$codePointAt(string, i);
        if (!$41a6607af35fbe66$var$isPrintable(char)) return $41a6607af35fbe66$var$STYLE_DOUBLE;
        plain = plain && $41a6607af35fbe66$var$isPlainSafe(char, prevChar, inblock);
        prevChar = char;
    }
    else {
        // Case: block styles permitted.
        for(i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
            char = $41a6607af35fbe66$var$codePointAt(string, i);
            if (char === $41a6607af35fbe66$var$CHAR_LINE_FEED) {
                hasLineBreak = true;
                // Check if any line can be folded.
                if (shouldTrackWidth) {
                    hasFoldableLine = hasFoldableLine || // Foldable line = too long, and not more-indented.
                    i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
                    previousLineBreak = i;
                }
            } else if (!$41a6607af35fbe66$var$isPrintable(char)) return $41a6607af35fbe66$var$STYLE_DOUBLE;
            plain = plain && $41a6607af35fbe66$var$isPlainSafe(char, prevChar, inblock);
            prevChar = char;
        }
        // in case the end is missing a \n
        hasFoldableLine = hasFoldableLine || shouldTrackWidth && i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
    }
    // Although every style can represent \n without escaping, prefer block styles
    // for multiline, since they're more readable and they don't add empty lines.
    // Also prefer folding a super-long line.
    if (!hasLineBreak && !hasFoldableLine) {
        // Strings interpretable as another type have to be quoted;
        // e.g. the string 'true' vs. the boolean true.
        if (plain && !forceQuotes && !testAmbiguousType(string)) return $41a6607af35fbe66$var$STYLE_PLAIN;
        return quotingType === $41a6607af35fbe66$var$QUOTING_TYPE_DOUBLE ? $41a6607af35fbe66$var$STYLE_DOUBLE : $41a6607af35fbe66$var$STYLE_SINGLE;
    }
    // Edge case: block indentation indicator can only have one digit.
    if (indentPerLevel > 9 && $41a6607af35fbe66$var$needIndentIndicator(string)) return $41a6607af35fbe66$var$STYLE_DOUBLE;
    // At this point we know block styles are valid.
    // Prefer literal style unless we want to fold.
    if (!forceQuotes) return hasFoldableLine ? $41a6607af35fbe66$var$STYLE_FOLDED : $41a6607af35fbe66$var$STYLE_LITERAL;
    return quotingType === $41a6607af35fbe66$var$QUOTING_TYPE_DOUBLE ? $41a6607af35fbe66$var$STYLE_DOUBLE : $41a6607af35fbe66$var$STYLE_SINGLE;
}
// Note: line breaking/folding is implemented for only the folded style.
// NB. We drop the last trailing newline (if any) of a returned block scalar
//  since the dumper adds its own newline. This always works:
//    • No ending newline => unaffected; already using strip "-" chomping.
//    • Ending newline    => removed then restored.
//  Importantly, this keeps the "+" chomp indicator from gaining an extra line.
function $41a6607af35fbe66$var$writeScalar(state, string, level, iskey, inblock) {
    state.dump = function() {
        if (string.length === 0) return state.quotingType === $41a6607af35fbe66$var$QUOTING_TYPE_DOUBLE ? '""' : "''";
        if (!state.noCompatMode) {
            if ($41a6607af35fbe66$var$DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1 || $41a6607af35fbe66$var$DEPRECATED_BASE60_SYNTAX.test(string)) return state.quotingType === $41a6607af35fbe66$var$QUOTING_TYPE_DOUBLE ? '"' + string + '"' : "'" + string + "'";
        }
        var indent = state.indent * Math.max(1, level); // no 0-indent scalars
        // As indentation gets deeper, let the width decrease monotonically
        // to the lower bound min(state.lineWidth, 40).
        // Note that this implies
        //  state.lineWidth ≤ 40 + state.indent: width is fixed at the lower bound.
        //  state.lineWidth > 40 + state.indent: width decreases until the lower bound.
        // This behaves better than a constant minimum width which disallows narrower options,
        // or an indent threshold which causes the width to suddenly increase.
        var lineWidth = state.lineWidth === -1 ? -1 : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent);
        // Without knowing if keys are implicit/explicit, assume implicit for safety.
        var singleLineOnly = iskey || state.flowLevel > -1 && level >= state.flowLevel;
        function testAmbiguity(string) {
            return $41a6607af35fbe66$var$testImplicitResolving(state, string);
        }
        switch($41a6607af35fbe66$var$chooseScalarStyle(string, singleLineOnly, state.indent, lineWidth, testAmbiguity, state.quotingType, state.forceQuotes && !iskey, inblock)){
            case $41a6607af35fbe66$var$STYLE_PLAIN:
                return string;
            case $41a6607af35fbe66$var$STYLE_SINGLE:
                return "'" + string.replace(/'/g, "''") + "'";
            case $41a6607af35fbe66$var$STYLE_LITERAL:
                return '|' + $41a6607af35fbe66$var$blockHeader(string, state.indent) + $41a6607af35fbe66$var$dropEndingNewline($41a6607af35fbe66$var$indentString(string, indent));
            case $41a6607af35fbe66$var$STYLE_FOLDED:
                return '>' + $41a6607af35fbe66$var$blockHeader(string, state.indent) + $41a6607af35fbe66$var$dropEndingNewline($41a6607af35fbe66$var$indentString($41a6607af35fbe66$var$foldString(string, lineWidth), indent));
            case $41a6607af35fbe66$var$STYLE_DOUBLE:
                return '"' + $41a6607af35fbe66$var$escapeString(string) + '"';
            default:
                throw new $41a6607af35fbe66$var$exception('impossible error: invalid scalar style');
        }
    }();
}
// Pre-conditions: string is valid for a block scalar, 1 <= indentPerLevel <= 9.
function $41a6607af35fbe66$var$blockHeader(string, indentPerLevel) {
    var indentIndicator = $41a6607af35fbe66$var$needIndentIndicator(string) ? String(indentPerLevel) : '';
    // note the special case: the string '\n' counts as a "trailing" empty line.
    var clip = string[string.length - 1] === '\n';
    var keep = clip && (string[string.length - 2] === '\n' || string === '\n');
    var chomp = keep ? '+' : clip ? '' : '-';
    return indentIndicator + chomp + '\n';
}
// (See the note for writeScalar.)
function $41a6607af35fbe66$var$dropEndingNewline(string) {
    return string[string.length - 1] === '\n' ? string.slice(0, -1) : string;
}
// Note: a long line without a suitable break point will exceed the width limit.
// Pre-conditions: every char in str isPrintable, str.length > 0, width > 0.
function $41a6607af35fbe66$var$foldString(string, width) {
    // In folded style, $k$ consecutive newlines output as $k+1$ newlines—
    // unless they're before or after a more-indented line, or at the very
    // beginning or end, in which case $k$ maps to $k$.
    // Therefore, parse each chunk as newline(s) followed by a content line.
    var lineRe = /(\n+)([^\n]*)/g;
    // first line (possibly an empty line)
    var result = function() {
        var nextLF = string.indexOf('\n');
        nextLF = nextLF !== -1 ? nextLF : string.length;
        lineRe.lastIndex = nextLF;
        return $41a6607af35fbe66$var$foldLine(string.slice(0, nextLF), width);
    }();
    // If we haven't reached the first content line yet, don't add an extra \n.
    var prevMoreIndented = string[0] === '\n' || string[0] === ' ';
    var moreIndented;
    // rest of the lines
    var match;
    while(match = lineRe.exec(string)){
        var prefix = match[1], line = match[2];
        moreIndented = line[0] === ' ';
        result += prefix + (!prevMoreIndented && !moreIndented && line !== '' ? '\n' : '') + $41a6607af35fbe66$var$foldLine(line, width);
        prevMoreIndented = moreIndented;
    }
    return result;
}
// Greedy line breaking.
// Picks the longest line under the limit each time,
// otherwise settles for the shortest line over the limit.
// NB. More-indented lines *cannot* be folded, as that would add an extra \n.
function $41a6607af35fbe66$var$foldLine(line, width) {
    if (line === '' || line[0] === ' ') return line;
    // Since a more-indented line adds a \n, breaks can't be followed by a space.
    var breakRe = / [^ ]/g; // note: the match index will always be <= length-2.
    var match;
    // start is an inclusive index. end, curr, and next are exclusive.
    var start = 0, end, curr = 0, next = 0;
    var result = '';
    // Invariants: 0 <= start <= length-1.
    //   0 <= curr <= next <= max(0, length-2). curr - start <= width.
    // Inside the loop:
    //   A match implies length >= 2, so curr and next are <= length-2.
    while(match = breakRe.exec(line)){
        next = match.index;
        // maintain invariant: curr - start <= width
        if (next - start > width) {
            end = curr > start ? curr : next; // derive end <= length-2
            result += '\n' + line.slice(start, end);
            // skip the space that was output as \n
            start = end + 1; // derive start <= length-1
        }
        curr = next;
    }
    // By the invariants, start <= length-1, so there is something left over.
    // It is either the whole string or a part starting from non-whitespace.
    result += '\n';
    // Insert a break if the remainder is too long and there is a break available.
    if (line.length - start > width && curr > start) result += line.slice(start, curr) + '\n' + line.slice(curr + 1);
    else result += line.slice(start);
    return result.slice(1); // drop extra \n joiner
}
// Escapes a double-quoted string.
function $41a6607af35fbe66$var$escapeString(string) {
    var result = '';
    var char = 0;
    var escapeSeq;
    for(var i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
        char = $41a6607af35fbe66$var$codePointAt(string, i);
        escapeSeq = $41a6607af35fbe66$var$ESCAPE_SEQUENCES[char];
        if (!escapeSeq && $41a6607af35fbe66$var$isPrintable(char)) {
            result += string[i];
            if (char >= 0x10000) result += string[i + 1];
        } else result += escapeSeq || $41a6607af35fbe66$var$encodeHex(char);
    }
    return result;
}
function $41a6607af35fbe66$var$writeFlowSequence(state, level, object) {
    var _result = '', _tag = state.tag, index, length, value;
    for(index = 0, length = object.length; index < length; index += 1){
        value = object[index];
        if (state.replacer) value = state.replacer.call(object, String(index), value);
        // Write only valid elements, put null instead of invalid elements.
        if ($41a6607af35fbe66$var$writeNode(state, level, value, false, false) || typeof value === 'undefined' && $41a6607af35fbe66$var$writeNode(state, level, null, false, false)) {
            if (_result !== '') _result += ',' + (!state.condenseFlow ? ' ' : '');
            _result += state.dump;
        }
    }
    state.tag = _tag;
    state.dump = '[' + _result + ']';
}
function $41a6607af35fbe66$var$writeBlockSequence(state, level, object, compact) {
    var _result = '', _tag = state.tag, index, length, value;
    for(index = 0, length = object.length; index < length; index += 1){
        value = object[index];
        if (state.replacer) value = state.replacer.call(object, String(index), value);
        // Write only valid elements, put null instead of invalid elements.
        if ($41a6607af35fbe66$var$writeNode(state, level + 1, value, true, true, false, true) || typeof value === 'undefined' && $41a6607af35fbe66$var$writeNode(state, level + 1, null, true, true, false, true)) {
            if (!compact || _result !== '') _result += $41a6607af35fbe66$var$generateNextLine(state, level);
            if (state.dump && $41a6607af35fbe66$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) _result += '-';
            else _result += '- ';
            _result += state.dump;
        }
    }
    state.tag = _tag;
    state.dump = _result || '[]'; // Empty sequence if no valid values.
}
function $41a6607af35fbe66$var$writeFlowMapping(state, level, object) {
    var _result = '', _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, pairBuffer;
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = '';
        if (_result !== '') pairBuffer += ', ';
        if (state.condenseFlow) pairBuffer += '"';
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (state.replacer) objectValue = state.replacer.call(object, objectKey, objectValue);
        if (!$41a6607af35fbe66$var$writeNode(state, level, objectKey, false, false)) continue; // Skip this pair because of invalid key;
        if (state.dump.length > 1024) pairBuffer += '? ';
        pairBuffer += state.dump + (state.condenseFlow ? '"' : '') + ':' + (state.condenseFlow ? '' : ' ');
        if (!$41a6607af35fbe66$var$writeNode(state, level, objectValue, false, false)) continue; // Skip this pair because of invalid value.
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = '{' + _result + '}';
}
function $41a6607af35fbe66$var$writeBlockMapping(state, level, object, compact) {
    var _result = '', _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, explicitPair, pairBuffer;
    // Allow sorting keys so that the output file is deterministic
    if (state.sortKeys === true) // Default sorting
    objectKeyList.sort();
    else if (typeof state.sortKeys === 'function') // Custom sort function
    objectKeyList.sort(state.sortKeys);
    else if (state.sortKeys) // Something is wrong
    throw new $41a6607af35fbe66$var$exception('sortKeys must be a boolean or a function');
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = '';
        if (!compact || _result !== '') pairBuffer += $41a6607af35fbe66$var$generateNextLine(state, level);
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (state.replacer) objectValue = state.replacer.call(object, objectKey, objectValue);
        if (!$41a6607af35fbe66$var$writeNode(state, level + 1, objectKey, true, true, true)) continue; // Skip this pair because of invalid key.
        explicitPair = state.tag !== null && state.tag !== '?' || state.dump && state.dump.length > 1024;
        if (explicitPair) {
            if (state.dump && $41a6607af35fbe66$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += '?';
            else pairBuffer += '? ';
        }
        pairBuffer += state.dump;
        if (explicitPair) pairBuffer += $41a6607af35fbe66$var$generateNextLine(state, level);
        if (!$41a6607af35fbe66$var$writeNode(state, level + 1, objectValue, true, explicitPair)) continue; // Skip this pair because of invalid value.
        if (state.dump && $41a6607af35fbe66$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += ':';
        else pairBuffer += ': ';
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = _result || '{}'; // Empty mapping if no valid pairs.
}
function $41a6607af35fbe66$var$detectType(state, object, explicit) {
    var _result, typeList, index, length, type, style;
    typeList = explicit ? state.explicitTypes : state.implicitTypes;
    for(index = 0, length = typeList.length; index < length; index += 1){
        type = typeList[index];
        if ((type.instanceOf || type.predicate) && (!type.instanceOf || (typeof object === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(object)) === 'object' && object instanceof type.instanceOf) && (!type.predicate || type.predicate(object))) {
            if (explicit) {
                if (type.multi && type.representName) state.tag = type.representName(object);
                else state.tag = type.tag;
            } else state.tag = '?';
            if (type.represent) {
                style = state.styleMap[type.tag] || type.defaultStyle;
                if ($41a6607af35fbe66$var$_toString.call(type.represent) === '[object Function]') _result = type.represent(object, style);
                else if ($41a6607af35fbe66$var$_hasOwnProperty.call(type.represent, style)) _result = type.represent[style](object, style);
                else throw new $41a6607af35fbe66$var$exception('!<' + type.tag + '> tag resolver accepts not "' + style + '" style');
                state.dump = _result;
            }
            return true;
        }
    }
    return false;
}
// Serializes `object` and writes it to global `result`.
// Returns true on success, or false on invalid object.
//
function $41a6607af35fbe66$var$writeNode(state, level, object, block, compact, iskey, isblockseq) {
    state.tag = null;
    state.dump = object;
    if (!$41a6607af35fbe66$var$detectType(state, object, false)) $41a6607af35fbe66$var$detectType(state, object, true);
    var type = $41a6607af35fbe66$var$_toString.call(state.dump);
    var inblock = block;
    var tagStr;
    if (block) block = state.flowLevel < 0 || state.flowLevel > level;
    var objectOrArray = type === '[object Object]' || type === '[object Array]', duplicateIndex, duplicate;
    if (objectOrArray) {
        duplicateIndex = state.duplicates.indexOf(object);
        duplicate = duplicateIndex !== -1;
    }
    if (state.tag !== null && state.tag !== '?' || duplicate || state.indent !== 2 && level > 0) compact = false;
    if (duplicate && state.usedDuplicates[duplicateIndex]) state.dump = '*ref_' + duplicateIndex;
    else {
        if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) state.usedDuplicates[duplicateIndex] = true;
        if (type === '[object Object]') {
            if (block && Object.keys(state.dump).length !== 0) {
                $41a6607af35fbe66$var$writeBlockMapping(state, level, state.dump, compact);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + state.dump;
            } else {
                $41a6607af35fbe66$var$writeFlowMapping(state, level, state.dump);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
            }
        } else if (type === '[object Array]') {
            if (block && state.dump.length !== 0) {
                if (state.noArrayIndent && !isblockseq && level > 0) $41a6607af35fbe66$var$writeBlockSequence(state, level - 1, state.dump, compact);
                else $41a6607af35fbe66$var$writeBlockSequence(state, level, state.dump, compact);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + state.dump;
            } else {
                $41a6607af35fbe66$var$writeFlowSequence(state, level, state.dump);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
            }
        } else if (type === '[object String]') {
            if (state.tag !== '?') $41a6607af35fbe66$var$writeScalar(state, state.dump, level, iskey, inblock);
        } else if (type === '[object Undefined]') return false;
        else {
            if (state.skipInvalid) return false;
            throw new $41a6607af35fbe66$var$exception('unacceptable kind of an object to dump ' + type);
        }
        if (state.tag !== null && state.tag !== '?') {
            // Need to encode all characters except those allowed by the spec:
            //
            // [35] ns-dec-digit    ::=  [#x30-#x39] /* 0-9 */
            // [36] ns-hex-digit    ::=  ns-dec-digit
            //                         | [#x41-#x46] /* A-F */ | [#x61-#x66] /* a-f */
            // [37] ns-ascii-letter ::=  [#x41-#x5A] /* A-Z */ | [#x61-#x7A] /* a-z */
            // [38] ns-word-char    ::=  ns-dec-digit | ns-ascii-letter | “-”
            // [39] ns-uri-char     ::=  “%” ns-hex-digit ns-hex-digit | ns-word-char | “#”
            //                         | “;” | “/” | “?” | “:” | “@” | “&” | “=” | “+” | “$” | “,”
            //                         | “_” | “.” | “!” | “~” | “*” | “'” | “(” | “)” | “[” | “]”
            //
            // Also need to encode '!' because it has special meaning (end of tag prefix).
            //
            tagStr = encodeURI(state.tag[0] === '!' ? state.tag.slice(1) : state.tag).replace(/!/g, '%21');
            if (state.tag[0] === '!') tagStr = '!' + tagStr;
            else if (tagStr.slice(0, 18) === 'tag:yaml.org,2002:') tagStr = '!!' + tagStr.slice(18);
            else tagStr = '!<' + tagStr + '>';
            state.dump = tagStr + ' ' + state.dump;
        }
    }
    return true;
}
function $41a6607af35fbe66$var$getDuplicateReferences(object, state) {
    var objects = [], duplicatesIndexes = [], index, length;
    $41a6607af35fbe66$var$inspectNode(object, objects, duplicatesIndexes);
    for(index = 0, length = duplicatesIndexes.length; index < length; index += 1)state.duplicates.push(objects[duplicatesIndexes[index]]);
    state.usedDuplicates = new Array(length);
}
function $41a6607af35fbe66$var$inspectNode(object, objects, duplicatesIndexes) {
    var objectKeyList, index, length;
    if (object !== null && (typeof object === "undefined" ? "undefined" : (0, $ef3a86602012e2c3$export$71511d61b312f219)(object)) === 'object') {
        index = objects.indexOf(object);
        if (index !== -1) {
            if (duplicatesIndexes.indexOf(index) === -1) duplicatesIndexes.push(index);
        } else {
            objects.push(object);
            if (Array.isArray(object)) for(index = 0, length = object.length; index < length; index += 1)$41a6607af35fbe66$var$inspectNode(object[index], objects, duplicatesIndexes);
            else {
                objectKeyList = Object.keys(object);
                for(index = 0, length = objectKeyList.length; index < length; index += 1)$41a6607af35fbe66$var$inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes);
            }
        }
    }
}
function $41a6607af35fbe66$var$dump$1(input, options) {
    options = options || {};
    var state = new $41a6607af35fbe66$var$State(options);
    if (!state.noRefs) $41a6607af35fbe66$var$getDuplicateReferences(input, state);
    var value = input;
    if (state.replacer) value = state.replacer.call({
        '': value
    }, '', value);
    if ($41a6607af35fbe66$var$writeNode(state, 0, value, true, true)) return state.dump + '\n';
    return '';
}
var $41a6607af35fbe66$var$dump_1 = $41a6607af35fbe66$var$dump$1;
var $41a6607af35fbe66$var$dumper = {
    dump: $41a6607af35fbe66$var$dump_1
};
function $41a6607af35fbe66$var$renamed(from, to) {
    return function() {
        throw new Error('Function yaml.' + from + ' is removed in js-yaml 4. ' + 'Use yaml.' + to + ' instead, which is now safe by default.');
    };
}
var $41a6607af35fbe66$export$92738401e1603719 = $41a6607af35fbe66$var$type;
var $41a6607af35fbe66$export$19342e026b58ebb7 = $41a6607af35fbe66$var$schema;
var $41a6607af35fbe66$export$aefe34bace55c48e = $41a6607af35fbe66$var$failsafe;
var $41a6607af35fbe66$export$3f5573a59aee743 = $41a6607af35fbe66$var$json;
var $41a6607af35fbe66$export$cb27b7e9f9bc8fa8 = $41a6607af35fbe66$var$core;
var $41a6607af35fbe66$export$54192bc17d2d9e2a = $41a6607af35fbe66$var$_default;
var $41a6607af35fbe66$export$11e63f7b0f3d9900 = $41a6607af35fbe66$var$loader.load;
var $41a6607af35fbe66$export$7aabae09a30b04c2 = $41a6607af35fbe66$var$loader.loadAll;
var $41a6607af35fbe66$export$2069a8a5a76faa2 = $41a6607af35fbe66$var$dumper.dump;
var $41a6607af35fbe66$export$28af3d4da69ed747 = $41a6607af35fbe66$var$exception;
// Re-export all types in case user wants to create custom schema
var $41a6607af35fbe66$export$b14ad400b1d09e0f = {
    binary: $41a6607af35fbe66$var$binary,
    float: $41a6607af35fbe66$var$float,
    map: $41a6607af35fbe66$var$map,
    null: $41a6607af35fbe66$var$_null,
    pairs: $41a6607af35fbe66$var$pairs,
    set: $41a6607af35fbe66$var$set,
    timestamp: $41a6607af35fbe66$var$timestamp,
    bool: $41a6607af35fbe66$var$bool,
    int: $41a6607af35fbe66$var$int,
    merge: $41a6607af35fbe66$var$merge,
    omap: $41a6607af35fbe66$var$omap,
    seq: $41a6607af35fbe66$var$seq,
    str: $41a6607af35fbe66$var$str
};
// Removed functions from JS-YAML 3.0.x
var $41a6607af35fbe66$export$ecc08907c0e2af9b = $41a6607af35fbe66$var$renamed('safeLoad', 'load');
var $41a6607af35fbe66$export$c2cc0f4fb6d29644 = $41a6607af35fbe66$var$renamed('safeLoadAll', 'loadAll');
var $41a6607af35fbe66$export$befffea07f2abcf0 = $41a6607af35fbe66$var$renamed('safeDump', 'dump');
var $41a6607af35fbe66$var$jsYaml = {
    Type: $41a6607af35fbe66$export$92738401e1603719,
    Schema: $41a6607af35fbe66$export$19342e026b58ebb7,
    FAILSAFE_SCHEMA: $41a6607af35fbe66$export$aefe34bace55c48e,
    JSON_SCHEMA: $41a6607af35fbe66$export$3f5573a59aee743,
    CORE_SCHEMA: $41a6607af35fbe66$export$cb27b7e9f9bc8fa8,
    DEFAULT_SCHEMA: $41a6607af35fbe66$export$54192bc17d2d9e2a,
    load: $41a6607af35fbe66$export$11e63f7b0f3d9900,
    loadAll: $41a6607af35fbe66$export$7aabae09a30b04c2,
    dump: $41a6607af35fbe66$export$2069a8a5a76faa2,
    YAMLException: $41a6607af35fbe66$export$28af3d4da69ed747,
    types: $41a6607af35fbe66$export$b14ad400b1d09e0f,
    safeLoad: $41a6607af35fbe66$export$ecc08907c0e2af9b,
    safeLoadAll: $41a6607af35fbe66$export$c2cc0f4fb6d29644,
    safeDump: $41a6607af35fbe66$export$befffea07f2abcf0
};
var $41a6607af35fbe66$export$2e2bcd8739ae039 = $41a6607af35fbe66$var$jsYaml;


var $23f790c4e0c22a37$export$d118786f359a8bfd = function(data, cache) {
    var dupes = [];
    var truncatedData = [];
    // Transpose cache
    var cacheByID = {};
    Object.keys(cache).forEach(function(key) {
        var arr = cache[key];
        arr.forEach(function(id) {
            cacheByID[id] = key;
        });
    });
    // Initial pass
    data.forEach(function(entry) {
        var category = entry.category.length > 0 ? entry.category[0].name : 'Other Program';
        if (!dupes.includes(entry.title) && ![
            'cancel',
            'brendan',
            '1-on-1'
        ].some(function(x) {
            return entry.title.toLowerCase().includes(x);
        }) && category !== "Holiday") {
            if (entry.allday) dupes.push(entry.title);
            var event = {
                "title": entry.title.replace("Bridgewater-Raritan High School", "BRHS"),
                "date": [
                    new Date(entry.start)
                ].concat(entry.future_dates.map(function(param) {
                    var start = param.start;
                    return new Date(start);
                })),
                "length": entry.allday ? 24 : (new Date(entry.end) - new Date(entry.start)) / $461264eed7066dae$export$371ef0f33bdee71f,
                "range": entry.allday && entry.future_dates.length > 2,
                "category": category,
                "image": cacheByID[entry.id],
                "form": entry.url.public
            };
            event.enddate = event.range ? new Date(event.date[event.date.length - 1]) : new Date(entry.end);
            event.schedule = "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=".concat($461264eed7066dae$export$78a7e49ccc71dc8c(event.date[0]), "%2F").concat($461264eed7066dae$export$78a7e49ccc71dc8c(event.enddate), "&location=Raritan%20Public%20Library&text=").concat(encodeURIComponent(event.title));
            event.datesort = event.date[0] < $461264eed7066dae$export$461939dd4422153 && event.length === "range" ? $461264eed7066dae$export$461939dd4422153 : event.date[0];
            truncatedData.push(event);
        }
    });
    truncatedData = truncatedData.sort(function(a, b) {
        return a.datesort - b.datesort;
    });
    // Begin injection
    var displayed = 0;
    var eventList = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = truncatedData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var event = _step.value;
            var eventDateTime = $461264eed7066dae$export$26e685d98fdeb12f(event.date[0]);
            if (displayed === 6) break;
            if (event.range) eventDateTime += " - ".concat($461264eed7066dae$export$26e685d98fdeb12f(event.enddate));
            else if (event.date.length > 1 && event.date[0].getDate() === event.date[1].getDate()) eventDateTime += " | ".concat($461264eed7066dae$export$3203edd9e5edd663(event.date[0]), " and ").concat($461264eed7066dae$export$3203edd9e5edd663(event.date[1]));
            else eventDateTime += " | ".concat($461264eed7066dae$export$3203edd9e5edd663(event.date[0]));
            if (event.enddate >= $461264eed7066dae$export$461939dd4422153 && event.category !== 'Reading Program') {
                eventList += '\n            <div class="event">\n                <div class="event-category">'.concat(event.category, '</div>\n                <div class="event-main">\n                    <picture class="event-image">\n                        <img src="img/events/').concat(event.image, '.jpg" alt="').concat(event.title, '" type="image/jpeg">\n                    </picture>\n                    <div class="event-info">\n                        <h2 class="event-header" href="').concat(event.form, '" target="_blank" rel="noopener">').concat(event.title, '</h2>\n                        <div class="event-datetime">').concat(eventDateTime, '</div>\n                        <div class="event-action">\n                            <a href="').concat(event.form, '" target="_blank" rel="noopener">Register</a>\n                            <a href="').concat(event.schedule, '" target="_blank" rel="noopener">Add to calendar</a>\n                        </div>\n                    </div>\n                </div>\n            </div>');
                displayed++;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Check for div
    var upcomingDiv = document.getElementById("upcoming");
    if (upcomingDiv) upcomingDiv.innerHTML = eventList;
};
var $23f790c4e0c22a37$export$20e0353d92eda19d = function(events, dateTime) {
    var curMonth = dateTime.getMonth();
    var curMonthName = $461264eed7066dae$export$a038b291f736c35e[curMonth];
    var curYear = dateTime.getFullYear();
    var lastDate = new Date(curYear, curMonth - 1, 1);
    var lastMonth = lastDate.getMonth();
    var lastMonthName = $461264eed7066dae$export$a038b291f736c35e[lastMonth];
    var lastYear = lastDate.getFullYear();
    var nextDate = new Date(curYear, curMonth + 1, 1);
    var nextMonth = nextDate.getMonth();
    var nextMonthName = $461264eed7066dae$export$a038b291f736c35e[nextMonth];
    var nextYear = nextDate.getFullYear();
    document.getElementById("calendar-month").innerHTML = "".concat(curMonthName, " ").concat(curYear);
    document.getElementById("calendar-nav-back").innerHTML = "\uD83E\uDC50 ".concat(lastMonthName, " ").concat(lastYear);
    document.getElementById("calendar-nav-next").innerHTML = "".concat(nextMonthName, " ").concat(nextYear, " \uD83E\uDC52");
    // Get day of the week for the first day of the month
    var monthFirst = new Date(curYear, dateTime.getMonth(), 1);
    var monthFirstDay = monthFirst.getDay();
    // Add all days of the month, starting from Sunday
    // Then count from that first day until the calendar is filled
    // Add events as you go through the calendar
    var calDate = new Date(curYear, dateTime.getMonth(), 1 - monthFirstDay);
    var calIter = 0;
    var calContent = "";
    var simpleNow = new Date($461264eed7066dae$export$461939dd4422153.getFullYear(), $461264eed7066dae$export$461939dd4422153.getMonth(), $461264eed7066dae$export$461939dd4422153.getDate());
    while(!(calIter > 6 && dateTime.getMonth() !== calDate.getMonth() && calDate.getDay() === 0)){
        var filteredEvents = events.filter(function(event) {
            return new Date(event.start).setHours(0, 0, 0, 0) === calDate.setHours(0, 0, 0, 0) && ![
                'cancel',
                'brendan',
                '1-on-1'
            ].some(function(x) {
                return event.title.toLowerCase().includes(x);
            });
        });
        var dayClass = dateTime.getMonth() !== calDate.getMonth() ? "-grey" : simpleNow.getTime() === calDate.getTime() ? "-now" : "";
        var hideEmpty = filteredEvents.length === 0 || calDate.getMonth() === simpleNow.getMonth() & calDate.getDate() < simpleNow.getDate() ? " calendar-day-empty" : "";
        calContent += ' \n        <div class="calendar-day'.concat(dayClass).concat(hideEmpty, '">\n            <div class="calendar-num">\n                <span class="calendar-num-dotw">').concat($461264eed7066dae$export$b7f7efbe9ab39b25(calDate), '</span>\n                <span class="calendar-num-date"><span class="calendar-num-date-month">').concat($461264eed7066dae$export$a038b291f736c35e[calDate.getMonth()], "</span> ").concat(calDate.getDate(), "</span>\n            </div>");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = filteredEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var event = _step.value;
                var eventTitle = event.title;
                var eventTime = event.allday ? "All Day Event" : "".concat($461264eed7066dae$export$3203edd9e5edd663(new Date(event.start)), " - ").concat($461264eed7066dae$export$3203edd9e5edd663(new Date(event.end)));
                calContent += '\n            <a class="calendar-entry-'.concat($f6be3119d5b3e79b$export$3ae65339208f6100(event.category), '" href="').concat(event.url.public, '" target="_blank" rel="noopener">\n                <span class="calendar-entry-').concat($f6be3119d5b3e79b$export$3ae65339208f6100(event.category), '-time">').concat(eventTime, "</span>\n                <span>").concat(eventTitle, "</span>\n            </a>");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        calContent += "</div>";
        calDate = new Date(calDate.getFullYear(), calDate.getMonth(), calDate.getDate() + 1);
        calIter++;
    }
    document.getElementById("calendar-weeks").innerHTML = calContent;
};
// Git data
var $23f790c4e0c22a37$var$rev = "388\n";
var $23f790c4e0c22a37$var$sha5 = "2d9979ba0459ff0e9e553774e81e8b4a7cb15aa5\n";
var $23f790c4e0c22a37$export$e85a8dcc29475cfa = function() {
    document.getElementById("git").innerHTML = '<a href="/site-map">Site Map</a> \xb7 <a href="/privacy"> Privacy</a> \xb7 v2.'.concat(String($23f790c4e0c22a37$var$rev - 346).padStart(3, '0'), " (").concat($23f790c4e0c22a37$var$sha5.slice(0, 7), ") ");
};



var $76185efcdf737b73$export$513ccb98c53b8039 = function() {
    var root = document.documentElement;
    if (localStorage.getItem("color-mode") === "dark") root.setAttribute("color-mode", "dark");
};
// Toggle light/dark mode
var $76185efcdf737b73$var$toggleMode = function(type) {
    var root = document.documentElement;
    var themeButton = document.getElementById("theme");
    var all = document.querySelectorAll("* :not(b):not(span):not(i):not(sup):not(path):not(svg)");
    var addRemove = type === "dark" ? "add" : "remove";
    themeButton.classList[addRemove]("darkmodeon");
    all.forEach(function(element) {
        return element.style.transition = "all 0.2s ease-in-out";
    });
    root.setAttribute("color-mode", type);
    localStorage.setItem("color-mode", type);
    setTimeout(function() {
        return all.forEach(function(element) {
            return element.style.transition = "";
        });
    }, 500);
};
var $76185efcdf737b73$export$f543642fc33c1018 = function() {
    var themeButton = document.getElementById("theme");
    if (localStorage.getItem("color-mode") === "dark") themeButton.classList.add("darkmodeon");
    $f6be3119d5b3e79b$export$187b105aa6466800(function(e) {
        if (themeButton.contains(e.target) && !themeButton.classList.contains("darkmodeon")) $76185efcdf737b73$var$toggleMode("dark");
        else if (themeButton.contains(e.target) && themeButton.classList.contains("darkmodeon")) $76185efcdf737b73$var$toggleMode("lite");
    });
};
var $76185efcdf737b73$export$dd08b95ed5ec19a6 = function() {
    var html = document.documentElement;
    var body = document.body;
    var upButton = document.getElementById("totop");
    // Calc height
    var width = $f6be3119d5b3e79b$export$3c49c185de0c2bfc();
    var height = 60;
    if (width > 1368) height = 0;
    else if (width >= 768) height = 84;
    else if (width >= 500) height = 76;
    // Appear when 20% below top
    document.addEventListener('scroll', function(e) {
        var element = body.scrollHeight - body.clientHeight === 0 ? html : body;
        var maxScroll = element.scrollHeight - element.clientHeight;
        var ratio = element.scrollTop / maxScroll;
        if (maxScroll / element.clientHeight >= 1) {
            if (element.scrollTop >= maxScroll * 0.2 + height * 2) upButton.style.top = "calc(100vh - ".concat(height, "px)");
            else if (ratio >= 0.2) upButton.style.top = "calc(100vh - ".concat((element.scrollTop - maxScroll * 0.2) / 2, "px)");
            else upButton.style.top = '100vh';
        } else upButton.style.top = '100vh';
    });
    // Scroll to top on click
    $f6be3119d5b3e79b$export$187b105aa6466800(function(e) {
        if (upButton.contains(e.target)) {
            html.scrollTop = 0; // chrome/ff/ie/opera
            body.scrollTop = 0; // safari
        }
    });
};



var $472521fac9b4024b$export$124049a9e3d0d4c3 = function() {
    // Slide information
    var container = document.getElementById('hero-content');
    var slides = Array.from(container.children);
    var dots = Array.from(document.getElementById('hero-select').children);
    var maxSlide = slides.length - 1;
    var firstSlide = slides[0];
    var lastSlide = slides[maxSlide];
    var cloneFirst = firstSlide.cloneNode(true);
    var cloneLast = lastSlide.cloneNode(true);
    var curSlide = 0;
    var curSlideMod = 0;
    var allowShift = true;
    var autoAdvance = true;
    var prev = document.getElementById("hero-prev");
    var next = document.getElementById("hero-next");
    // Clone first/last slides
    container.appendChild(cloneFirst);
    container.insertBefore(cloneLast, firstSlide);
    slides = Array.from(container.children);
    slides.forEach(function(slide) {
        return slide.style.transform = "translateX(-100%)";
    });
    // Wait for transition
    var transitionEndSelector = function() {
        var e = document.createElement('fakeelement');
        var transitions = {
            'transition': 'transitionend',
            'OTransition': 'oTransitionEnd',
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
        };
        for(var t in transitions){
            if (e.style[t] !== undefined) return transitions[t];
        }
    };
    var transitionEnd = transitionEndSelector();
    // Shift logic
    var shift = function(n) {
        // Add transition
        slides.forEach(function(slide) {
            return slide.classList.add('shift');
        });
        // Unset slide dot
        document.getElementById("hero-dot-".concat(curSlide)).classList.remove('hero-select-current');
        // Advance slide
        curSlide = curSlide + n;
        curSlideMod = $f6be3119d5b3e79b$export$842a2cf37af977e1(curSlide, maxSlide + 1);
        slides.forEach(function(slide) {
            return slide.style.transform = "translateX(".concat(-100 * (curSlide + 1), "%)");
        });
        // Set slide dot
        document.getElementById("hero-dot-".concat(curSlideMod)).classList.add('hero-select-current');
        // Check to allow shifting
        allowShift = curSlide === curSlideMod;
    };
    // Remove transition after finish, account for edge slides
    var checkIndex = function() {
        slides.forEach(function(slide) {
            return slide.classList.remove('shift');
        });
        if (curSlide === -1) {
            slides.forEach(function(slide) {
                return slide.style.transform = "translateX(".concat(-100 * maxSlide - 100, "%)");
            });
            curSlide = maxSlide;
        } else if (curSlide === maxSlide + 1) {
            slides.forEach(function(slide) {
                return slide.style.transform = "translateX(-100%)";
            });
            curSlide = 0;
        }
        allowShift = true;
    };
    // Navigation listeners
    $f6be3119d5b3e79b$export$187b105aa6466800(function(e) {
        // Arrows
        if (prev.contains(e.target) && allowShift) {
            autoAdvance = false;
            shift(-1);
        } else if (next.contains(e.target) && allowShift) {
            autoAdvance = false;
            shift(1);
        }
        // Dots
        dots.forEach(function(dot, i) {
            if (dot.contains(e.target) && allowShift) {
                autoAdvance = false;
                shift(i - curSlide);
            }
        });
    });
    // Transition listeners
    slides.forEach(function(slide) {
        return slide.addEventListener(transitionEnd, checkIndex);
    });
    // Auto-advance until clicked
    setInterval(function() {
        if (autoAdvance) shift(1);
    }, 8500);
};




var $ff6042dcc133874a$var$_biJson = '{\r\n    "1": {"name": "Joe Abercrombie"},\r\n    "2": {"name": "Elizabeth Adler"},\r\n    "3": {"name": "Susan Wittig Albert"},\r\n    "4": {"name": "Mitch Albom"},\r\n    "5": {"name": "Isabel Allende"},\r\n    "6": {"name": "Mary Kay Andrews"},\r\n    "7": {"name": "Jeffrey Archer"},\r\n    "8": {"name": "Ace Atkins"},\r\n    "9": {"name": "Kate Atkinson"},\r\n    "10": {"name": "Margaret Atwood"},\r\n    "11": {"name": "Fredrik Backman"},\r\n    "12": {"name": "David Baldacci"},\r\n    "13": {"name": "Mary Balough"},\r\n    "14": {"name": "Leigh Bardugo"},\r\n    "15": {"name": "Nevada Barr"},\r\n    "16": {"name": "M. C. Beaton"},\r\n    "17": {"name": "Alex Berenson"},\r\n    "18": {"name": "Elizabeth Berg"},\r\n    "19": {"name": "Steve Berry"},\r\n    "20": {"name": "Chris Bohjalian"},\r\n    "21": {"name": "Rhys Bowen"},\r\n    "22": {"name": "C. J. Box"},\r\n    "23": {"name": "Barbara Bradford"},\r\n    "24": {"name": "Geraldine Brooks"},\r\n    "25": {"name": "Terry Brooks"},\r\n    "26": {"name": "Dale Brown"},\r\n    "27": {"name": "Dan Brown"},\r\n    "28": {"name": "Rita Mae Brown"},\r\n    "29": {"name": "Sandra Brown"},\r\n    "30": {"name": "Alafair Burke"},\r\n    "31": {"name": "James Lee Burke"},\r\n    "32": {"name": "Jim Butcher"},\r\n    "33": {"name": "Meg Cabot"},\r\n    "34": {"name": "Orson Scott Card"},\r\n    "35": {"name": "Robyn Carr"},\r\n    "36": {"name": "Linda Castillo"},\r\n    "37": {"name": "Michael Chabon"},\r\n    "38": {"name": "Diane Chamberlain"},\r\n    "39": {"name": "Tracy Chevalier"},\r\n    "40": {"name": "Jennifer Chiaverini"},\r\n    "41": {"name": "Lee Child"},\r\n    "42": {"name": "Lincoln Child"},\r\n    "43": {"name": "Laura Childs"},\r\n    "44": {"name": "Carol Higgins Clark"},\r\n    "45": {"name": "Mary Jane Clark"},\r\n    "46": {"name": "Harlan Coben"},\r\n    "47": {"name": "Michael Connelly"},\r\n    "48": {"name": "John Connolly"},\r\n    "49": {"name": "Robin Cook"},\r\n    "50": {"name": "James S. A. Corey"},\r\n    "51": {"name": "Bernard Cornwell"},\r\n    "52": {"name": "Patricia Cornwell"},\r\n    "53": {"name": "Catherine Coulter"},\r\n    "54": {"name": "Robert Crais"},\r\n    "55": {"name": "Blake Crouch"},\r\n    "56": {"name": "Clive Cussler"},\r\n    "57": {"name": "Janet Dailey"},\r\n    "58": {"name": "Jeffery Deaver"},\r\n    "59": {"name": "Ted Dekker"},\r\n    "60": {"name": "Barbara Delinsky"},\r\n    "61": {"name": "Nelson Demille"},\r\n    "62": {"name": "Jude Deveraux"},\r\n    "63": {"name": "Anita Diamant"},\r\n    "64": {"name": "Louise Erdrich"},\r\n    "65": {"name": "Janet Evanovich"},\r\n    "66": {"name": "Richard Paul Evans"},\r\n    "67": {"name": "Linda Fairstein"},\r\n    "68": {"name": "Christine Feehan"},\r\n    "69": {"name": "Joy Fielding"},\r\n    "70": {"name": "Fannie Flagg"},\r\n    "71": {"name": "Joanne Fluke"},\r\n    "72": {"name": "Gillian Flynn"},\r\n    "73": {"name": "Vince Flynn"},\r\n    "74": {"name": "Ken Follett"},\r\n    "75": {"name": "Tana French"},\r\n    "76": {"name": "Diana Gabaldon"},\r\n    "77": {"name": "Neil Gaiman"},\r\n    "78": {"name": "Robert Galbraith"},\r\n    "79": {"name": "Lisa Gardner"},\r\n    "80": {"name": "Julie Garwood"},\r\n    "81": {"name": "Elizabeth George"},\r\n    "82": {"name": "Tess Gerritsen"},\r\n    "83": {"name": "Emily Giffin"},\r\n    "84": {"name": "Heather Graham"},\r\n    "85": {"name": "Jane Green"},\r\n    "86": {"name": "Philippa Gregory"},\r\n    "87": {"name": "W. E. B. Griffin"},\r\n    "88": {"name": "Martha Grimes"},\r\n    "89": {"name": "James Grippando"},\r\n    "90": {"name": "John Grisham"},\r\n    "91": {"name": "Sara Gruen"},\r\n    "92": {"name": "Laurell K. Hamilton"},\r\n    "93": {"name": "Kristin Hannah"},\r\n    "94": {"name": "Charlaine Harris"},\r\n    "95": {"name": "Grady Hendrix"},\r\n    "96": {"name": "Carl Hiaasen"},\r\n    "97": {"name": "Elin Hilderbrand"},\r\n    "98": {"name": "Joe Hill"},\r\n    "99": {"name": "Tami Hoag"},\r\n    "100": {"name": "Alice Hoffman"},\r\n    "101": {"name": "Khaled Hosseini"},\r\n    "102": {"name": "Stephen Hunter"},\r\n    "103": {"name": "Greg Iles"},\r\n    "104": {"name": "John Irving"},\r\n    "105": {"name": "Lisa Jackson"},\r\n    "106": {"name": "J. A. Jance"},\r\n    "107": {"name": "N. K. Jemisin"},\r\n    "108": {"name": "Iris Johansen"},\r\n    "109": {"name": "Craig Johnson"},\r\n    "110": {"name": "Jan Karon"},\r\n    "111": {"name": "Alex Kava"},\r\n    "112": {"name": "Faye Kellerman"},\r\n    "113": {"name": "Jonathan Kellerman"},\r\n    "114": {"name": "Sherrilyn Kenyon"},\r\n    "115": {"name": "Sue Monk Kidd"},\r\n    "116": {"name": "Laurie R. King"},\r\n    "117": {"name": "Stephen King"},\r\n    "118": {"name": "Karen Kingsbury"},\r\n    "119": {"name": "Barbara Kingsolver"},\r\n    "120": {"name": "Sophie Kinsella"},\r\n    "121": {"name": "Lisa Kleypas"},\r\n    "122": {"name": "Dean Koontz"},\r\n    "123": {"name": "Jayne Ann Krentz"},\r\n    "124": {"name": "Dennis Lehane"},\r\n    "125": {"name": "John Lescroart"},\r\n    "126": {"name": "Beverly Lewis"},\r\n    "127": {"name": "Ken Liu"},\r\n    "128": {"name": "Debbie Macomber"},\r\n    "129": {"name": "Susan Mallery"},\r\n    "130": {"name": "Phillip Margolin"},\r\n    "131": {"name": "George R. R. Martin"},\r\n    "132": {"name": "Steve Martini"},\r\n    "133": {"name": "Alexander McCall Smith"},\r\n    "134": {"name": "Terry McMillan"},\r\n    "135": {"name": "Brad Meltzer"},\r\n    "136": {"name": "Fern Michaels"},\r\n    "137": {"name": "Sue Miller"},\r\n    "138": {"name": "Mary Alice Monroe"},\r\n    "139": {"name": "Liane Moriarty"},\r\n    "140": {"name": "Kate Morton"},\r\n    "141": {"name": "Sarah Moss"},\r\n    "142": {"name": "JoJo Moyes"},\r\n    "143": {"name": "Carla Neggers"},\r\n    "144": {"name": "Jo Nesbo"},\r\n    "145": {"name": "Joyce Carol Oates"},\r\n    "146": {"name": "Nnedi Okorafor"},\r\n    "147": {"name": "Sara Paretsky"},\r\n    "148": {"name": "T. Jefferson Parker"},\r\n    "149": {"name": "Ann Patchett"},\r\n    "150": {"name": "James Patterson"},\r\n    "151": {"name": "Richard North Patterson"},\r\n    "152": {"name": "Louise Penny"},\r\n    "153": {"name": "Anne Perry"},\r\n    "154": {"name": "Jodi Picoult"},\r\n    "155": {"name": "Douglas Preston"},\r\n    "156": {"name": "Amanda Quick"},\r\n    "157": {"name": "Anna Quindlen"},\r\n    "158": {"name": "Ian Rankin"},\r\n    "159": {"name": "Kathy Reichs"},\r\n    "160": {"name": "Taylor Jenkins Reid"},\r\n    "161": {"name": "Luanne Rice"},\r\n    "162": {"name": "Francine Rivers"},\r\n    "163": {"name": "Karen Robards"},\r\n    "164": {"name": "J. D. Robb"},\r\n    "165": {"name": "Nora Roberts"},\r\n    "166": {"name": "James Rollins"},\r\n    "167": {"name": "Patrick Rothfuss"},\r\n    "168": {"name": "Brandon Sanderson"},\r\n    "169": {"name": "John Sandford"},\r\n    "170": {"name": "John Scalzi"},\r\n    "171": {"name": "Lisa Scottoline"},\r\n    "172": {"name": "Lisa See"},\r\n    "173": {"name": "Jeff Shaara"},\r\n    "174": {"name": "Anita Shreve"},\r\n    "175": {"name": "Daniel Silva"},\r\n    "176": {"name": "Karin Slaughter"},\r\n    "177": {"name": "Nicholas Sparks"},\r\n    "178": {"name": "Danielle Steel"},\r\n    "179": {"name": "Elizabeth Strout"},\r\n    "180": {"name": "Amy Tan"},\r\n    "181": {"name": "Donna Tartt"},\r\n    "182": {"name": "Nancy Thayer"},\r\n    "183": {"name": "Brad Thor"},\r\n    "184": {"name": "Adriana Trigiani"},\r\n    "185": {"name": "Scott Turow"},\r\n    "186": {"name": "Anne Tyler"},\r\n    "187": {"name": "Lisa Unger"},\r\n    "188": {"name": "Jeff VanderMeer"},\r\n    "189": {"name": "Jeannette Walls"},\r\n    "190": {"name": "Ruth Ware"},\r\n    "191": {"name": "Jennifer Weiner"},\r\n    "192": {"name": "Andy Weir"},\r\n    "193": {"name": "Martha Wells"},\r\n    "194": {"name": "Randy Wayne White"},\r\n    "195": {"name": "Colson Whitehead"},\r\n    "196": {"name": "Susan Wiggs"},\r\n    "197": {"name": "Jacqueline Winspear"},\r\n    "198": {"name": "Sherryl Woods"},\r\n    "199": {"name": "Stuart Woods"}\r\n}';
var $ff6042dcc133874a$var$biJson = JSON.parse($ff6042dcc133874a$var$_biJson);
var $ff6042dcc133874a$export$545bf518be75e25a = function() {
    // Slide information
    var container = document.getElementById('bookit');
    var displayNum = 10;
    var author = function() {
        var id = $f6be3119d5b3e79b$export$b141de964f0a90c1(199);
        return '<picture class="bookit-img">\n            <img src="/img/bookit/'.concat(id, '.jpg" alt="').concat($ff6042dcc133874a$var$biJson[id].name, '" type="image/jpeg">\n        </picture>');
    };
    // Add inital content set
    for(var i = 0; i < displayNum; i++)container.innerHTML += author();
    // Shift logic
    var shift = function() {
        // Remove first child, add new random
        container.removeChild(container.firstElementChild);
        container.innerHTML += author();
        // Update children list
        var children = Array.from(container.children);
        // Advance slide
        children.forEach(function(child, i) {
            return child.style.transform = "translateX(".concat((i - 2) * 100, "%)");
        });
        setTimeout(function() {
            children.forEach(function(child, i) {
                return child.style.transform = "translateX(".concat((i - 3) * 100, "%)");
            });
        }, 20);
    };
    // Auto-advance
    shift();
    setInterval(shift, 12000);
};



var $d13d14116446991c$exports = {};

$d13d14116446991c$exports = (parcelRequire("gcgwq")).getBundleURL('1dpzq') + "calendar.8ac659bd.json";


var $40be50de96bc08e9$exports = {};

$40be50de96bc08e9$exports = (parcelRequire("gcgwq")).getBundleURL('1dpzq') + "hashcache.7defbf8b.json";


// Get page details
var $bb5b6dc32cb0ceb5$var$url = window.location.href;
var $bb5b6dc32cb0ceb5$var$page;
try {
    $bb5b6dc32cb0ceb5$var$page = $bb5b6dc32cb0ceb5$var$url.split("/")[3];
    $bb5b6dc32cb0ceb5$var$page = $bb5b6dc32cb0ceb5$var$page.split(".")[0];
} catch (e) {
    $bb5b6dc32cb0ceb5$var$page = '';
}
// Autoscroll if linked (default)
var $bb5b6dc32cb0ceb5$var$autoScroll = function() {
    var urlClean = $bb5b6dc32cb0ceb5$var$url.split("#")[1];
    if (urlClean) {
        var scrollId = document.getElementById(urlClean);
        scrollId.scrollIntoView();
    }
};
// Content to inject for events page
var $bb5b6dc32cb0ceb5$var$contentEvents = function(res) {
    $23f790c4e0c22a37$export$20e0353d92eda19d(res, $461264eed7066dae$export$461939dd4422153);
    var curMonth = $461264eed7066dae$export$461939dd4422153.getMonth();
    var curYear = $461264eed7066dae$export$461939dd4422153.getFullYear();
    var lastDate = new Date(curYear, curMonth - 1, 1);
    var nextDate = new Date(curYear, curMonth + 1, 1);
    var lastLimit = new Date(curYear, curMonth, 1);
    var nextLimit = new Date(curYear, curMonth + 3, 1);
    var disableLeft = true;
    var disableRight = false;
    $f6be3119d5b3e79b$export$187b105aa6466800(function(e) {
        var navLeft = document.getElementById("calendar-nav-back");
        var navRight = document.getElementById("calendar-nav-next");
        if (navLeft.contains(e.target) && !disableLeft) {
            $23f790c4e0c22a37$export$20e0353d92eda19d(res, lastDate);
            curMonth = lastDate.getMonth();
            curYear = lastDate.getFullYear();
            if (lastDate.getTime() === lastLimit.getTime()) {
                navLeft.classList.add("calendar-action-grey");
                disableLeft = true;
            }
            navRight.classList.remove("calendar-action-grey");
            disableRight = false;
            lastDate = new Date(curYear, curMonth - 1, 1);
            nextDate = new Date(curYear, curMonth + 1, 1);
        } else if (navRight.contains(e.target) && !disableRight) {
            $23f790c4e0c22a37$export$20e0353d92eda19d(res, nextDate);
            curMonth = nextDate.getMonth();
            curYear = nextDate.getFullYear();
            if (nextDate.getTime() === nextLimit.getTime()) {
                navRight.classList.add("calendar-action-grey");
                disableRight = true;
            }
            navLeft.classList.remove("calendar-action-grey");
            disableLeft = false;
            lastDate = new Date(curYear, curMonth - 1, 1);
            nextDate = new Date(curYear, curMonth + 1, 1);
        }
    });
    $bb5b6dc32cb0ceb5$var$autoScroll();
};
// Search bar
var $bb5b6dc32cb0ceb5$var$search = function() {
    var searchForm = document.getElementById('search');
    searchForm.addEventListener("submit", function(e) {
        var keyword = document.getElementById('query').value;
        e.preventDefault();
        if (keyword !== '') {
            keyword.replace(' ', '+');
            window.location.replace("https://raritan.aspendiscovery.org/Union/Search?view=list&lookfor=".concat(keyword, "&searchIndex=Keyword&searchSource=local"));
            return false;
        }
    });
};
var $bb5b6dc32cb0ceb5$var$pageInjector = function(p) {
    if (p === '') {
        $472521fac9b4024b$export$124049a9e3d0d4c3();
        $ff6042dcc133874a$export$545bf518be75e25a();
    }
    if (p === 'bookit') $ff6042dcc133874a$export$545bf518be75e25a();
    if (p.includes('board')) $bb5b6dc32cb0ceb5$var$autoScroll();
};
$7f19431eca38d161$export$81207e5cc4186890();
$7f19431eca38d161$export$4bd4b47501432316();
$76185efcdf737b73$export$513ccb98c53b8039();
// Load event/hashcache data
var $bb5b6dc32cb0ceb5$var$eventResFunc = /*#__PURE__*/ function() {
    var _ref = (0, $b32efe327c8459fb$export$71511d61b312f219)(function(res) {
        var cache;
        return (0, $2ffd1edbe3502dec$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    res = res.events;
                    return [
                        4,
                        fetch((0, (/*@__PURE__*/$parcel$interopDefault($40be50de96bc08e9$exports)))).then(function(x) {
                            return x.json();
                        })
                    ];
                case 1:
                    cache = _state.sent();
                    $23f790c4e0c22a37$export$d118786f359a8bfd(res, cache);
                    if ($bb5b6dc32cb0ceb5$var$page.includes('events')) $bb5b6dc32cb0ceb5$var$contentEvents(res);
                    return [
                        2
                    ];
            }
        });
    });
    return function eventResFunc(res) {
        return _ref.apply(this, arguments);
    };
}();
$f6be3119d5b3e79b$export$f46232c2a9c34923((0, (/*@__PURE__*/$parcel$interopDefault($d13d14116446991c$exports))), $bb5b6dc32cb0ceb5$var$eventResFunc);
window.onload = function() {
    $461264eed7066dae$export$813e98560751a081();
    $bb5b6dc32cb0ceb5$var$pageInjector($bb5b6dc32cb0ceb5$var$page);
    $76185efcdf737b73$export$f543642fc33c1018();
    $76185efcdf737b73$export$dd08b95ed5ec19a6();
    $23f790c4e0c22a37$export$e85a8dcc29475cfa();
    $bb5b6dc32cb0ceb5$var$search();
};

})();
//# sourceMappingURL=403.2d3096d4.js.map
